// industryMarkdown/utils/injectStyles.ts
var isInjected = false;
function injectHighlightStyles() {
  if (isInjected || typeof document === "undefined") {
    return;
  }
  const existingStyle = document.getElementById("themed-markdown-highlight-css");
  if (existingStyle) {
    isInjected = true;
    return;
  }
  const css = `
pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em
}
code.hljs {
  padding: 3px 5px
}

.hljs {
  color: #abb2bf;
  background: #282c34
}
.hljs-comment,
.hljs-quote {
  color: #5c6370;
  font-style: italic
}
.hljs-doctag,
.hljs-keyword,
.hljs-formula {
  color: #c678dd
}
.hljs-section,
.hljs-name,
.hljs-selector-tag,
.hljs-deletion,
.hljs-subst {
  color: #e06c75
}
.hljs-literal {
  color: #56b6c2
}
.hljs-string,
.hljs-regexp,
.hljs-addition,
.hljs-attribute,
.hljs-meta .hljs-string {
  color: #98c379
}
.hljs-attr,
.hljs-variable,
.hljs-template-variable,
.hljs-type,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-number {
  color: #d19a66
}
.hljs-symbol,
.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-title {
  color: #61aeee
}
.hljs-built_in,
.hljs-title.class_,
.hljs-class .hljs-title {
  color: #e6c07b
}
.hljs-emphasis {
  font-style: italic
}
.hljs-strong {
  font-weight: bold
}
.hljs-link {
  text-decoration: underline
}`;
  const styleElement = document.createElement("style");
  styleElement.id = "themed-markdown-highlight-css";
  styleElement.textContent = css;
  document.head.appendChild(styleElement);
  isInjected = true;
}
injectHighlightStyles();

// node_modules/@principal-ade/industry-theme/dist/esm/index.js
import React, { createContext, useContext, useState, useEffect } from "react";
import React2 from "react";
var landingPageTheme = {
  space: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 100, 128],
  fonts: {
    body: 'Inter, "Geist Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    heading: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monospace: '"SF Mono", Monaco, Inconsolata, "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.2,
    tight: 1.05,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px", "1400px"],
  sizes: [16, 32, 64, 128, 200, 240, 256, 300, 512, 740, 768, 820, 900, 1024, 1200, 1400, 1536],
  radii: [0, 2, 4, 6, 7, 8, 9, 10, 12, 14, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 4px 12px rgba(0, 194, 255, 0.4)",
    "0 6px 24px rgba(0, 194, 255, 0.1)",
    "0 8px 32px rgba(0, 0, 0, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50, 1000],
  colors: {
    text: "#ffffff",
    background: "#000000",
    primary: "#00C2FF",
    secondary: "#0098CC",
    accent: "#0066FF",
    highlight: "#001d26",
    muted: "#1a1a1a",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#002733",
    backgroundSecondary: "#0a1628",
    backgroundTertiary: "#0f1c2e",
    backgroundLight: "#00080a",
    backgroundHover: "#00131a",
    surface: "#000000",
    textSecondary: "#d1d5db",
    textTertiary: "#9ca3af",
    textMuted: "#6b7280",
    highlightBg: "#403b0f",
    highlightBorder: "#80761e",
    textOnPrimary: "#000000",
    textOnSecondary: "#ffffff",
    textOnAccent: "#ffffff"
  },
  buttons: {
    primary: {
      color: "#000000",
      bg: "#00C2FF",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00D9FF"
      }
    },
    secondary: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#003a4d",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00131a",
        borderColor: "#00C2FF"
      }
    },
    ghost: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#00D9FF",
        bg: "#00131a"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "#ffffff"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
      color: "text"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 4
    },
    secondary: {
      bg: "#000a0d",
      border: "1px solid",
      borderColor: "#002733",
      borderRadius: 4
    }
  }
};
var landingPageLightTheme = {
  ...landingPageTheme,
  colors: {
    text: "#1a1a1a",
    background: "#ffffff",
    primary: "#0098CC",
    secondary: "#00C2FF",
    accent: "#0066FF",
    highlight: "#e6f5fa",
    muted: "#f0f0f0",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#cceaf5",
    backgroundSecondary: "#f8f9fa",
    backgroundTertiary: "#e9ecef",
    backgroundLight: "#f7fcfd",
    backgroundHover: "#f2fafc",
    surface: "#ffffff",
    textSecondary: "#555555",
    textTertiary: "#888888",
    textMuted: "#aaaaaa",
    highlightBg: "#fff9c4",
    highlightBorder: "#fff389",
    textOnPrimary: "#ffffff",
    textOnSecondary: "#000000",
    textOnAccent: "#ffffff"
  },
  buttons: {
    primary: {
      color: "#ffffff",
      bg: "#0098CC",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#007aa8"
      }
    },
    secondary: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#b2e0f0",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#f2fafc",
        borderColor: "#0098CC"
      }
    },
    ghost: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#007aa8",
        bg: "#f2fafc"
      }
    }
  }
};
var regalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Crimson Text", "Georgia", "Times New Roman", serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#f1e8dc",
    background: "#1a1f2e",
    primary: "#d4a574",
    secondary: "#e0b584",
    accent: "#c9b8a3",
    highlight: "#363338",
    muted: "#8b7968",
    success: "#5c8a72",
    warning: "#d4a574",
    error: "#a85751",
    info: "#d4a574",
    border: "#3f3a3c",
    backgroundSecondary: "#212738",
    backgroundTertiary: "#2d3446",
    backgroundLight: "#292a34",
    backgroundHover: "#363338",
    surface: "#212738",
    textSecondary: "#c9b8a3",
    textTertiary: "#8b7968",
    textMuted: "#8b7968",
    highlightBg: "#534724",
    highlightBorder: "#8c701a",
    textOnPrimary: "#1a1f2e",
    textOnSecondary: "#1a1f2e",
    textOnAccent: "#1a1f2e"
  },
  buttons: {
    primary: {
      color: "background",
      bg: "primary",
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "text",
      bg: "muted",
      "&:hover": {
        bg: "backgroundSecondary"
      }
    },
    ghost: {
      color: "primary",
      bg: "transparent",
      "&:hover": {
        bg: "muted"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "background",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    }
  }
};
var terminalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    heading: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    monospace: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.4,
    relaxed: 1.8
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px 0 rgba(0, 0, 0, 0.07)",
    "0 8px 12px 0 rgba(0, 0, 0, 0.08)",
    "0 16px 24px 0 rgba(0, 0, 0, 0.10)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#e4e4e4",
    background: "#0a0a0a",
    primary: "#66b3ff",
    secondary: "#80c4ff",
    accent: "#66ff99",
    highlight: "#18283d",
    muted: "#1a1a1a",
    success: "#66ff99",
    warning: "#ffcc66",
    error: "#ff6666",
    info: "#66b3ff",
    border: "#1a1a1a",
    backgroundSecondary: "#0f0f0f",
    backgroundTertiary: "#141414",
    backgroundLight: "#0d0d0d",
    backgroundHover: "#0d1520",
    surface: "#0f0f0f",
    textSecondary: "#b3b3b3",
    textTertiary: "#808080",
    textMuted: "#666666",
    highlightBg: "#40391e",
    highlightBorder: "#7f7530",
    textOnPrimary: "#ffffff",
    textOnSecondary: "#0a0a0a",
    textOnAccent: "#0a0a0a"
  },
  modes: {
    light: {
      text: "#1a1a1a",
      background: "#ffffff",
      primary: "#0066cc",
      secondary: "#0052a3",
      accent: "#00cc88",
      highlight: "#e6f2ff",
      muted: "#f5f5f5",
      success: "#00cc88",
      warning: "#ffaa00",
      error: "#ff3333",
      info: "#0066cc",
      border: "#e6e6e6",
      backgroundSecondary: "#fafafa",
      backgroundTertiary: "#f5f5f5",
      backgroundLight: "#fafafa",
      backgroundHover: "#f5f9fd",
      surface: "#ffffff",
      textSecondary: "#666666",
      textTertiary: "#999999",
      textMuted: "#b3b3b3",
      highlightBg: "#fff9c4",
      highlightBorder: "#fff389",
      textOnPrimary: "#ffffff",
      textOnSecondary: "#ffffff",
      textOnAccent: "#ffffff"
    }
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    }
  }
};
var matrixTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 0 5px rgba(0, 216, 53, 0.15)",
    "0 0 10px rgba(0, 216, 53, 0.2)",
    "0 0 15px rgba(0, 216, 53, 0.25)",
    "0 0 20px rgba(0, 216, 53, 0.3)",
    "0 0 30px rgba(0, 216, 53, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#00d835",
    secondary: "#00a828",
    accent: "#00d835",
    highlight: "#002008",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#002b0b",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#000602",
    backgroundHover: "#001104",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#00360d",
    highlightBorder: "#006c1b",
    textOnPrimary: "#000000",
    textOnSecondary: "#000000",
    textOnAccent: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var matrixMinimalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px rgba(0, 0, 0, 0.05)",
    "0 2px 4px rgba(0, 0, 0, 0.1)",
    "0 4px 8px rgba(0, 0, 0, 0.15)",
    "0 8px 16px rgba(0, 0, 0, 0.2)",
    "0 0 20px rgba(0, 216, 53, 0.1)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#b8b8b8",
    secondary: "#909090",
    accent: "#00d835",
    highlight: "#001605",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#121212",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#040404",
    backgroundHover: "#000b03",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#002b0b",
    highlightBorder: "#005615",
    textOnPrimary: "#000000",
    textOnSecondary: "#000000",
    textOnAccent: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "backgroundHover"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var slateTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.2)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.2)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.25)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.3)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#9ca3af",
    background: "#1a1c1e",
    primary: "#d1d5db",
    secondary: "#6b7280",
    accent: "#f59e0b",
    highlight: "#353838",
    muted: "#2d3134",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#3b82f6",
    border: "#2d3034",
    backgroundSecondary: "#22252a",
    backgroundTertiary: "#2d3134",
    backgroundLight: "#202325",
    backgroundHover: "#27292c",
    surface: "#1f2124",
    textSecondary: "#e5e7eb",
    textTertiary: "#6b7280",
    textMuted: "#4b5563",
    highlightBg: "#513c19",
    highlightBorder: "#875d14",
    textOnPrimary: "#1a1c1e",
    textOnSecondary: "#e5e7eb",
    textOnAccent: "#1a1c1e"
  },
  buttons: {
    primary: {
      color: "#1a1c1e",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "#9ca3af"
      }
    },
    secondary: {
      color: "#e5e7eb",
      bg: "secondary",
      borderWidth: 0,
      "&:hover": {
        bg: "#4b5563"
      }
    },
    ghost: {
      color: "textSecondary",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "textSecondary"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textTertiary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    }
  }
};
function getMode(theme, mode) {
  if (!mode || !theme.modes || !theme.modes[mode]) {
    return theme.colors;
  }
  return {
    ...theme.colors,
    ...theme.modes[mode]
  };
}
var ThemeContext;
var getThemeContext = () => {
  if (typeof window !== "undefined") {
    const globalWindow = window;
    if (!globalWindow.__principlemd_theme_context__) {
      globalWindow.__principlemd_theme_context__ = createContext(undefined);
    }
    return globalWindow.__principlemd_theme_context__;
  } else {
    if (!ThemeContext) {
      ThemeContext = createContext(undefined);
    }
    return ThemeContext;
  }
};
var ThemeContextSingleton = getThemeContext();
var useTheme = () => {
  const context = useContext(ThemeContextSingleton);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
var ThemeProvider = ({
  children,
  theme: customTheme = theme,
  initialMode
}) => {
  const [mode, setMode] = useState(initialMode);
  const activeTheme = React.useMemo(() => {
    if (!mode || !customTheme.modes || !customTheme.modes[mode]) {
      return customTheme;
    }
    return {
      ...customTheme,
      colors: getMode(customTheme, mode)
    };
  }, [customTheme, mode]);
  useEffect(() => {
    if (!initialMode) {
      const savedMode = localStorage.getItem("principlemd-theme-mode");
      if (savedMode) {
        setMode(savedMode);
      }
    }
  }, [initialMode]);
  useEffect(() => {
    if (mode) {
      localStorage.setItem("principlemd-theme-mode", mode);
    } else {
      localStorage.removeItem("principlemd-theme-mode");
    }
  }, [mode]);
  const value = {
    theme: activeTheme,
    mode,
    setMode
  };
  return /* @__PURE__ */ React.createElement(ThemeContextSingleton.Provider, {
    value
  }, children);
};
var withTheme = (Component) => {
  return (props) => {
    const { theme: theme2 } = useTheme();
    return /* @__PURE__ */ React.createElement(Component, {
      ...props,
      theme: theme2
    });
  };
};
var theme = terminalTheme;
function scaleThemeFonts(theme2, scale) {
  const currentScale = theme2.fontScale || 1;
  const effectiveScale = scale / currentScale;
  return {
    ...theme2,
    fontSizes: theme2.fontSizes.map((size) => Math.round(size * effectiveScale)),
    fontScale: scale
  };
}
function increaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.min(currentScale * 1.1, 2);
  return scaleThemeFonts(theme2, newScale);
}
function decreaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.max(currentScale * 0.9, 0.5);
  return scaleThemeFonts(theme2, newScale);
}
function resetFontScale(theme2) {
  return scaleThemeFonts(theme2, 1);
}

// industryMarkdown/components/IndustryMarkdownSlide.tsx
import { defaultSchema } from "hast-util-sanitize";
import React13, { useRef as useRef7, useEffect as useEffect7, useLayoutEffect, useState as useState9, useMemo as useMemo2, useCallback } from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";

// industryMarkdown/utils/highlightSearchMatches.ts
function highlightSearchMatches(content, searchQuery) {
  if (!searchQuery || !searchQuery.trim()) {
    return content;
  }
  const escapedQuery = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const codeBlockRegex = /(```[\s\S]*?```|`[^`]+`)/g;
  const segments = [];
  let lastIndex = 0;
  let match;
  const codeMatches = [];
  while ((match = codeBlockRegex.exec(content)) !== null) {
    codeMatches.push({
      start: match.index,
      end: match.index + match[0].length,
      text: match[0]
    });
  }
  if (codeMatches.length === 0) {
    segments.push({ text: content, isCode: false });
  } else {
    codeMatches.forEach((codeMatch) => {
      if (lastIndex < codeMatch.start) {
        segments.push({
          text: content.slice(lastIndex, codeMatch.start),
          isCode: false
        });
      }
      segments.push({
        text: codeMatch.text,
        isCode: true
      });
      lastIndex = codeMatch.end;
    });
    if (lastIndex < content.length) {
      segments.push({
        text: content.slice(lastIndex),
        isCode: false
      });
    }
  }
  const highlightedSegments = segments.map((segment) => {
    if (segment.isCode) {
      return segment.text;
    }
    const regex = new RegExp(`(${escapedQuery})`, "gi");
    return segment.text.replace(regex, "<mark>$1</mark>");
  });
  return highlightedSegments.join("");
}

// node_modules/@principal-ade/markdown-utils/dist/esm/index.js
var CHUNK_TYPES = {
  MARKDOWN: "markdown_chunk",
  MERMAID: "mermaid_chunk",
  SLIDE: "slide_chunk",
  CODE: "code_chunk"
};
var MarkdownSourceType;
((MarkdownSourceType2) => {
  MarkdownSourceType2["WORKSPACE_FILE"] = "workspace_file";
  MarkdownSourceType2["REMOTE_FILE"] = "remote_file";
  MarkdownSourceType2["GITHUB_FILE"] = "github_file";
  MarkdownSourceType2["DRAFT"] = "draft";
  MarkdownSourceType2["GITHUB_ISSUE"] = "github_issue";
  MarkdownSourceType2["GITHUB_PULL_REQUEST"] = "github_pull_request";
  MarkdownSourceType2["GITHUB_GIST"] = "github_gist";
})(MarkdownSourceType ||= {});
function hashMarkdownString(str) {
  let hash = 0;
  for (let i = 0;i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
}
function parseMarkdownChunks(markdownContent, idPrefix, customParsers) {
  try {
    if (typeof markdownContent !== "string") {
      throw new Error("Invalid markdown content provided");
    }
    if (!markdownContent || markdownContent.trim() === "") {
      return [];
    }
    const chunks = [];
    const mermaidRegex = /^```mermaid\n([\s\S]*?)\n^```$/gm;
    let lastIndex = 0;
    let match;
    let partCounter = 0;
    while ((match = mermaidRegex.exec(markdownContent)) !== null) {
      partCounter++;
      if (match.index > lastIndex) {
        const mdContent = markdownContent.substring(lastIndex, match.index);
        if (mdContent.trim()) {
          chunks.push({
            type: CHUNK_TYPES.MARKDOWN,
            content: mdContent,
            id: `${idPrefix}-md-${partCounter}-${hashMarkdownString(mdContent)}`
          });
        }
      }
      partCounter++;
      const mermaidContent = match[1].trim();
      chunks.push({
        type: CHUNK_TYPES.MERMAID,
        content: mermaidContent,
        id: `${idPrefix}-mermaid-${partCounter}-${hashMarkdownString(mermaidContent)}`
      });
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < markdownContent.length) {
      partCounter++;
      const remainingMdContent = markdownContent.substring(lastIndex);
      if (remainingMdContent.trim()) {
        chunks.push({
          type: CHUNK_TYPES.MARKDOWN,
          content: remainingMdContent,
          id: `${idPrefix}-md-${partCounter}-${hashMarkdownString(remainingMdContent)}`
        });
      }
    }
    if (chunks.length === 0 && markdownContent.trim()) {
      chunks.push({
        type: CHUNK_TYPES.MARKDOWN,
        content: markdownContent,
        id: `${idPrefix}-md-only-${hashMarkdownString(markdownContent)}`
      });
    }
    if (customParsers && customParsers.length > 0) {
      let processedChunks = chunks;
      for (const parser of customParsers) {
        const newChunks = [];
        for (const chunk of processedChunks) {
          if (chunk.type === CHUNK_TYPES.MARKDOWN) {
            const parsed = parser(chunk.content, chunk.id);
            if (parsed.length > 0) {
              newChunks.push(...parsed);
            } else {
              newChunks.push(chunk);
            }
          } else {
            newChunks.push(chunk);
          }
        }
        processedChunks = newChunks;
      }
      return processedChunks;
    }
    return chunks;
  } catch (error) {
    console.error("Error in parseMarkdownChunks:", error);
    return markdownContent ? [
      {
        type: CHUNK_TYPES.MARKDOWN,
        content: markdownContent,
        id: `${idPrefix}-md-error-fallback-${hashMarkdownString(markdownContent)}`
      }
    ] : [];
  }
}
function hashMarkdownString2(str) {
  let hash = 0;
  for (let i = 0;i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
}
function extractSlideTitle(content) {
  const lines = content.split(`
`).filter((line) => line.trim());
  for (const line of lines) {
    const headingMatch = line.match(/^#+\s+(.+)$/);
    if (headingMatch) {
      return headingMatch[1].trim();
    }
  }
  if (lines.length > 0) {
    const firstLine = lines[0];
    return firstLine.length > 50 ? firstLine.substring(0, 47) + "..." : firstLine;
  }
  return "Untitled Slide";
}
function parseMarkdownIntoPresentation(markdownContent, repositoryInfo, customParsers) {
  const hasMultipleHeaders = detectMultipleHeaders(markdownContent);
  if (!hasMultipleHeaders) {
    const id = `slide-0-${hashMarkdownString2(markdownContent)}`;
    const chunks = parseMarkdownChunks(markdownContent, id, customParsers);
    return {
      slides: [
        {
          id,
          title: extractSlideTitle(markdownContent),
          location: {
            startLine: 0,
            endLine: markdownContent.split(`
`).length - 1,
            content: markdownContent
          },
          chunks
        }
      ],
      originalContent: markdownContent,
      repositoryInfo
    };
  }
  const lines = markdownContent.split(`
`);
  const slides = [];
  let currentSlideLines = [];
  let currentSlideStartLine = 0;
  let inCodeBlock = false;
  let codeBlockDelimiter = "";
  for (let i = 0;i < lines.length; i++) {
    const line = lines[i];
    if (line.trim().startsWith("```") || line.trim().startsWith("~~~")) {
      if (!inCodeBlock) {
        inCodeBlock = true;
        codeBlockDelimiter = line.trim().substring(0, 3);
      } else if (line.trim().startsWith(codeBlockDelimiter)) {
        inCodeBlock = false;
        codeBlockDelimiter = "";
      }
    }
    const isDelimiter = !inCodeBlock && line.trim().startsWith("#") && !line.trim().startsWith("###");
    if (isDelimiter && currentSlideLines.length > 0) {
      const slideContent = currentSlideLines.join(`
`);
      const slideId = `slide-${slides.length}-${hashMarkdownString2(slideContent)}`;
      const chunks = parseMarkdownChunks(slideContent, slideId, customParsers);
      slides.push({
        id: slideId,
        title: extractSlideTitle(slideContent),
        location: {
          startLine: currentSlideStartLine,
          endLine: i - 1,
          content: slideContent
        },
        chunks
      });
      currentSlideLines = [line];
      currentSlideStartLine = i;
    } else {
      currentSlideLines.push(line);
    }
  }
  if (currentSlideLines.length > 0) {
    const slideContent = currentSlideLines.join(`
`);
    const slideId = `slide-${slides.length}-${hashMarkdownString2(slideContent)}`;
    const chunks = parseMarkdownChunks(slideContent, slideId, customParsers);
    slides.push({
      id: slideId,
      title: extractSlideTitle(slideContent),
      location: {
        startLine: currentSlideStartLine,
        endLine: lines.length - 1,
        content: slideContent
      },
      chunks
    });
  }
  return {
    slides,
    originalContent: markdownContent,
    repositoryInfo
  };
}
function detectMultipleHeaders(markdownContent) {
  const lines = markdownContent.split(`
`);
  let h1Count = 0;
  let h2Count = 0;
  let inCodeBlock = false;
  let codeBlockDelimiter = "";
  for (const line of lines) {
    if (line.trim().startsWith("```") || line.trim().startsWith("~~~")) {
      if (!inCodeBlock) {
        inCodeBlock = true;
        codeBlockDelimiter = line.trim().substring(0, 3);
      } else if (line.trim().startsWith(codeBlockDelimiter)) {
        inCodeBlock = false;
        codeBlockDelimiter = "";
      }
    }
    if (!inCodeBlock) {
      if (line.trim().startsWith("#") && !line.trim().startsWith("###")) {
        if (!line.trim().startsWith("##")) {
          h1Count++;
        } else {
          h2Count++;
        }
      }
    }
  }
  const totalHeaders = h1Count + h2Count;
  return totalHeaders > 1;
}
function parseBashCommands(codeString) {
  const lines = codeString.split(`
`);
  const commands = [];
  let currentCommand = "";
  let commandStartLine = 0;
  let currentDescription = "";
  let inBackslashContinuation = false;
  for (let i = 0;i < lines.length; i++) {
    const rawLine = lines[i];
    const line = rawLine.trim();
    if (!line) {
      if (currentCommand && !inBackslashContinuation) {
        commands.push({
          command: currentCommand.trim(),
          description: currentDescription || undefined,
          line: commandStartLine + 1
        });
        currentCommand = "";
        currentDescription = "";
      }
      continue;
    }
    if (line.startsWith("#")) {
      if (!currentCommand) {
        currentDescription = line.substring(1).trim();
      }
      continue;
    }
    const endsWithBackslash = rawLine.trimEnd().endsWith("\\");
    if (endsWithBackslash || inBackslashContinuation) {
      if (!currentCommand) {
        commandStartLine = i;
      }
      if (endsWithBackslash) {
        const content = rawLine.trimEnd().slice(0, -1).trim();
        currentCommand += (currentCommand ? " " : "") + content;
        inBackslashContinuation = true;
      } else {
        currentCommand += (currentCommand ? " " : "") + line;
        inBackslashContinuation = false;
      }
      continue;
    }
    const isPipeContinuation = line.startsWith("|") || line.startsWith("&&") || line.startsWith("||");
    const previousLineEndsWithOperator = currentCommand && (currentCommand.trim().endsWith("|") || currentCommand.trim().endsWith("&&") || currentCommand.trim().endsWith("||") || currentCommand.trim().endsWith(";"));
    if (currentCommand && (isPipeContinuation || previousLineEndsWithOperator)) {
      currentCommand += (currentCommand.endsWith(" ") ? "" : " ") + line;
      continue;
    }
    if (currentCommand) {
      commands.push({
        command: currentCommand.trim(),
        description: currentDescription || undefined,
        line: commandStartLine + 1
      });
      currentDescription = "";
    }
    commandStartLine = i;
    currentCommand = line;
  }
  if (currentCommand) {
    commands.push({
      command: currentCommand.trim(),
      description: currentDescription || undefined,
      line: commandStartLine + 1
    });
  }
  return commands.filter((cmd) => cmd.command.length > 0);
}
function getCommandDisplayName(command, maxLength = 50) {
  if (command.description) {
    return command.description.length <= maxLength ? command.description : command.description.substring(0, maxLength - 3) + "...";
  }
  const cmdText = command.command;
  if (cmdText.length <= maxLength) {
    return cmdText;
  }
  return cmdText.substring(0, maxLength - 3) + "...";
}
function isRelativeUrl(url) {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return false;
  }
  if (url.startsWith("//")) {
    return false;
  }
  if (url.startsWith("data:")) {
    return false;
  }
  if (url.startsWith("blob:")) {
    return false;
  }
  return true;
}
function transformImageUrl(src, repositoryInfo) {
  if (!repositoryInfo || !isRelativeUrl(src)) {
    return src;
  }
  const { owner, repo, branch = "main", basePath = "" } = repositoryInfo;
  let fullPath;
  if (src.startsWith("/")) {
    fullPath = src.substring(1);
  } else {
    let cleanPath = src;
    if (cleanPath.startsWith("./")) {
      cleanPath = cleanPath.substring(2);
    }
    if (cleanPath.startsWith("../")) {
      console.warn("Relative parent directory navigation in image URLs is not fully supported:", src);
      cleanPath = cleanPath.replace(/^(\.\.\/)+/, "");
    }
    if (basePath) {
      const cleanBasePath = basePath.replace(/^\/+|\/+$/g, "");
      fullPath = `${cleanBasePath}/${cleanPath}`;
    } else {
      fullPath = cleanPath;
    }
  }
  const rawUrl = `https://raw.githubusercontent.com/${owner}/${repo}/${branch}/${fullPath}`;
  return rawUrl;
}
class SkillParseError extends Error {
  cause;
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    this.name = "SkillParseError";
  }
}

class SkillValidationError extends Error {
  field;
  constructor(message, field) {
    super(message);
    this.field = field;
    this.name = "SkillValidationError";
  }
}
function extractFrontmatter(content) {
  const trimmed = content.trim();
  if (!trimmed.startsWith("---")) {
    throw new SkillParseError("SKILL.md must start with YAML frontmatter (---)");
  }
  const afterFirstDelimiter = trimmed.slice(3);
  const closingIndex = afterFirstDelimiter.indexOf(`
---`);
  if (closingIndex === -1) {
    throw new SkillParseError("SKILL.md frontmatter is not properly closed with ---");
  }
  const frontmatter = afterFirstDelimiter.slice(0, closingIndex).trim();
  const body = afterFirstDelimiter.slice(closingIndex + 4).trim();
  return { frontmatter, body };
}
function parseYamlFrontmatter(yaml) {
  const result = {};
  const lines = yaml.split(`
`);
  let currentKey = null;
  let currentObject = null;
  let currentList = null;
  for (let i = 0;i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith("#")) {
      continue;
    }
    const lineIndent = line.search(/\S/);
    if (trimmed.startsWith("- ")) {
      const value = trimmed.slice(2).trim();
      if (currentList) {
        currentList.push(value);
      }
      continue;
    }
    const colonIndex = line.indexOf(":");
    if (colonIndex > 0) {
      const key = line.slice(0, colonIndex).trim();
      const value = line.slice(colonIndex + 1).trim();
      if (lineIndent === 0) {
        currentKey = key;
        currentList = null;
        currentObject = null;
        if (!value) {
          if (i + 1 < lines.length) {
            const nextLine = lines[i + 1];
            const nextTrimmed = nextLine.trim();
            if (nextTrimmed.startsWith("- ")) {
              currentList = [];
              result[key] = currentList;
            } else if (nextLine.search(/\S/) > 0 && nextLine.includes(":")) {
              currentObject = {};
              result[key] = currentObject;
            }
          }
        } else {
          const cleanValue = value.replace(/^["']|["']$/g, "");
          result[key] = cleanValue;
        }
      } else if (lineIndent > 0 && currentObject) {
        const cleanValue = value.replace(/^["']|["']$/g, "");
        currentObject[key] = cleanValue;
      }
    }
  }
  return result;
}
function validateSkillMetadata(metadata) {
  if (!metadata.name || typeof metadata.name !== "string" || !metadata.name.trim()) {
    throw new SkillValidationError('Required field "name" is missing or empty', "name");
  }
  if (!metadata.description || typeof metadata.description !== "string" || !metadata.description.trim()) {
    throw new SkillValidationError('Required field "description" is missing or empty', "description");
  }
  if (metadata.license !== undefined && typeof metadata.license !== "string") {
    throw new SkillValidationError('Field "license" must be a string', "license");
  }
  if (metadata.compatibility !== undefined && typeof metadata.compatibility !== "string") {
    throw new SkillValidationError('Field "compatibility" must be a string', "compatibility");
  }
  if (metadata["allowed-tools"] !== undefined) {
    if (typeof metadata["allowed-tools"] === "string") {
      const toolsString = metadata["allowed-tools"];
      metadata["allowed-tools"] = toolsString.trim() ? toolsString.trim().split(/\s+/) : [];
    } else {
      throw new SkillValidationError('Field "allowed-tools" must be a space-delimited string', "allowed-tools");
    }
  }
  if (metadata.metadata !== undefined && (typeof metadata.metadata !== "object" || Array.isArray(metadata.metadata))) {
    throw new SkillValidationError('Field "metadata" must be an object', "metadata");
  }
  const skillMetadata = {
    name: metadata.name,
    description: metadata.description
  };
  if (metadata.license !== undefined) {
    skillMetadata.license = metadata.license;
  }
  if (metadata.compatibility !== undefined) {
    skillMetadata.compatibility = metadata.compatibility;
  }
  if (metadata["allowed-tools"] !== undefined) {
    skillMetadata["allowed-tools"] = metadata["allowed-tools"];
  }
  if (metadata.metadata !== undefined) {
    skillMetadata.metadata = metadata.metadata;
  }
  return skillMetadata;
}
function parseSkillMarkdown(content) {
  try {
    const { frontmatter, body } = extractFrontmatter(content);
    let rawMetadata;
    try {
      rawMetadata = parseYamlFrontmatter(frontmatter);
    } catch (error) {
      throw new SkillParseError("Failed to parse YAML frontmatter", error);
    }
    const metadata = validateSkillMetadata(rawMetadata);
    return {
      metadata,
      body,
      raw: content
    };
  } catch (error) {
    if (error instanceof SkillParseError || error instanceof SkillValidationError) {
      throw error;
    }
    throw new SkillParseError("Failed to parse SKILL.md", error);
  }
}

// industryMarkdown/utils/markdownUtils.ts
var parseMarkdownChunks2 = parseMarkdownChunks;

// industryMarkdown/components/IndustryHtmlModal.tsx
import React3, { useState as useState2 } from "react";
var useIndustryHtmlModal = () => {
  const [htmlModalOpen, setHtmlModalOpen] = useState2(false);
  const [htmlModalContent, setHtmlModalContent] = useState2("");
  const openHtmlModal = (content) => {
    setHtmlModalContent(content);
    setHtmlModalOpen(true);
  };
  const closeHtmlModal = () => {
    setHtmlModalOpen(false);
  };
  return { htmlModalOpen, htmlModalContent, openHtmlModal, closeHtmlModal };
};
function IndustryHtmlModal({ isOpen, onClose, htmlContent, theme: theme2 }) {
  if (!isOpen)
    return null;
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
    padding: theme2.space[6]
  };
  const modalStyle = {
    backgroundColor: theme2.colors.background,
    borderRadius: theme2.radii[3],
    maxWidth: "900px",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme2.colors.border}`,
    boxShadow: theme2.shadows[4]
  };
  const headerStyle = {
    padding: theme2.space[4],
    borderBottom: `1px solid ${theme2.colors.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme2.colors.backgroundSecondary
  };
  const contentStyle = {
    padding: theme2.space[5],
    overflow: "auto",
    flex: 1,
    backgroundColor: theme2.colors.background,
    color: theme2.colors.text
  };
  const titleStyle = {
    margin: 0,
    color: theme2.colors.text,
    fontSize: theme2.fontSizes[3],
    fontWeight: theme2.fontWeights.semibold,
    fontFamily: theme2.fonts.heading
  };
  const closeButtonStyle = {
    background: "transparent",
    border: "none",
    fontSize: theme2.fontSizes[5],
    cursor: "pointer",
    color: theme2.colors.textSecondary,
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    borderRadius: theme2.radii[1],
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px"
  };
  const handleCloseButtonHover = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.backgroundTertiary;
    e.currentTarget.style.color = theme2.colors.text;
  };
  const handleCloseButtonLeave = (e) => {
    e.currentTarget.style.backgroundColor = "transparent";
    e.currentTarget.style.color = theme2.colors.textSecondary;
  };
  return /* @__PURE__ */ React3.createElement("div", {
    style: overlayStyle,
    onClick: onClose
  }, /* @__PURE__ */ React3.createElement("div", {
    style: modalStyle,
    onClick: (e) => e.stopPropagation()
  }, /* @__PURE__ */ React3.createElement("div", {
    style: headerStyle
  }, /* @__PURE__ */ React3.createElement("h3", {
    style: titleStyle
  }, "HTML Preview"), /* @__PURE__ */ React3.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: closeButtonStyle,
    onMouseEnter: handleCloseButtonHover,
    onMouseLeave: handleCloseButtonLeave,
    title: "Close",
    "aria-label": "Close modal"
  }, "×")), /* @__PURE__ */ React3.createElement("div", {
    style: contentStyle
  }, /* @__PURE__ */ React3.createElement("div", {
    dangerouslySetInnerHTML: { __html: htmlContent }
  }))));
}

// industryMarkdown/components/IndustryLazyMermaidDiagram.tsx
import { MoveRight } from "lucide-react";
import React6, { useEffect as useEffect3, useRef as useRef2, useState as useState4 } from "react";

// industryMarkdown/components/IndustryMermaidDiagram.tsx
import { Expand, Copy, Check } from "lucide-react";
import React5, { useEffect as useEffect2, useRef, useState as useState3 } from "react";
var getMermaidSync = () => {
  if (typeof window !== "undefined") {
    const mermaid = window.mermaid;
    if (mermaid) {
      return mermaid;
    }
  }
  return null;
};
function IndustryMermaidDiagram({
  code,
  id,
  theme: themeOverride,
  onCopyError,
  onError,
  rootMargin = "200px",
  isModalMode = false,
  isFullSlide = false,
  onExpandClick
}) {
  const theme2 = themeOverride ?? theme;
  const [errorDetails, setErrorDetails] = useState3(null);
  const [isIntersecting, setIsIntersecting] = useState3(false);
  const [hasRendered, setHasRendered] = useState3(false);
  const [containerElement, setContainerElement] = useState3(null);
  const [copiedError, setCopiedError] = useState3(false);
  const observerRef = useRef(null);
  const containerRef = React5.useCallback((node) => {
    setContainerElement(node);
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node && !hasRendered) {
      if (isModalMode || typeof IntersectionObserver === "undefined") {
        setIsIntersecting(true);
        setHasRendered(true);
        return;
      }
      observerRef.current = new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
        if (entry.isIntersecting && !hasRendered) {
          setHasRendered(true);
        }
      }, {
        rootMargin,
        threshold: 0.01
      });
      observerRef.current.observe(node);
    }
  }, [rootMargin, hasRendered, isModalMode]);
  useEffect2(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  useEffect2(() => {
    if (!hasRendered)
      return;
    const renderDiagram = async () => {
      const mermaid = getMermaidSync();
      if (!mermaid || !containerElement)
        return;
      try {
        const diagramBackground = isModalMode ? "transparent" : theme2.colors.backgroundSecondary || theme2.colors.background;
        const nodeBackground = theme2.colors.backgroundTertiary || theme2.colors.backgroundSecondary || theme2.colors.primary + "22";
        mermaid.initialize({
          startOnLoad: false,
          theme: "base",
          themeVariables: {
            primaryColor: nodeBackground,
            primaryTextColor: theme2.colors.text,
            primaryBorderColor: theme2.colors.border,
            secondaryColor: theme2.colors.secondary + "44",
            tertiaryColor: theme2.colors.accent + "44",
            background: diagramBackground,
            mainBkg: nodeBackground,
            secondBkg: theme2.colors.backgroundSecondary || theme2.colors.muted,
            tertiaryBkg: theme2.colors.backgroundTertiary || theme2.colors.accent + "22",
            altBackground: theme2.colors.muted,
            clusterBkg: theme2.colors.muted || theme2.colors.backgroundTertiary || theme2.colors.backgroundSecondary,
            clusterBorder: theme2.colors.border,
            titleColor: theme2.colors.text,
            lineColor: theme2.colors.border,
            secondaryBorderColor: theme2.colors.border,
            tertiaryBorderColor: theme2.colors.accent,
            textColor: theme2.colors.text,
            labelTextColor: theme2.colors.text,
            nodeTextColor: theme2.colors.text,
            edgeLabelBackground: theme2.colors.background,
            errorBkgColor: theme2.colors.error + "33",
            errorTextColor: theme2.colors.error
          },
          securityLevel: "loose",
          logLevel: "error"
        });
        containerElement.innerHTML = "";
        const elementId = `mermaid-${id}-${Date.now()}`;
        const { svg, bindFunctions } = await mermaid.render(elementId, code);
        containerElement.innerHTML = svg;
        if (bindFunctions) {
          bindFunctions(containerElement);
        }
        const svgElement = containerElement.querySelector("svg");
        if (svgElement) {
          svgElement.style.maxWidth = "none";
          svgElement.style.maxHeight = "none";
          svgElement.style.width = "auto";
          svgElement.style.height = "auto";
          svgElement.style.display = "block";
          svgElement.style.margin = "0 auto";
          if (!svgElement.getAttribute("preserveAspectRatio")) {
            svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet");
          }
          if (isFullSlide) {
            svgElement.style.width = "100%";
            svgElement.style.height = "100%";
            svgElement.style.maxWidth = "100%";
            svgElement.style.maxHeight = "100%";
            svgElement.style.objectFit = "contain";
          } else if (isModalMode) {
            svgElement.style.width = "auto";
            svgElement.style.height = "auto";
            svgElement.style.maxWidth = "none";
            svgElement.style.maxHeight = "none";
            svgElement.style.minWidth = "auto";
            svgElement.style.minHeight = "auto";
            const viewBox = svgElement.getAttribute("viewBox");
            if (viewBox) {
              const [, , width, height] = viewBox.split(" ").map(Number);
              if (width && height) {
                svgElement.setAttribute("width", width.toString());
                svgElement.setAttribute("height", height.toString());
              }
            }
          } else {
            svgElement.style.maxHeight = "360px";
            svgElement.style.width = "100%";
            svgElement.style.maxWidth = "100%";
          }
        } else {
          console.warn("No SVG element found after mermaid render");
        }
        setErrorDetails(null);
        if (onError)
          onError(false);
      } catch (err) {
        console.error("Mermaid rendering error:", err);
        const errorMessage = err instanceof Error ? err.message : "Failed to render diagram";
        setErrorDetails({ code, message: errorMessage });
        if (onError)
          onError(true);
        if (containerElement) {
          containerElement.innerHTML = "";
        }
      }
    };
    renderDiagram();
  }, [hasRendered, code, id, theme2, containerElement, onError, isModalMode, isFullSlide]);
  const handleCopyError = async () => {
    if (!errorDetails)
      return;
    const errorText = `Mermaid Rendering Error:
${errorDetails.message}

Failed Mermaid Code:
\`\`\`mermaid
${errorDetails.code}
\`\`\``;
    try {
      await navigator.clipboard.writeText(errorText);
      setCopiedError(true);
      setTimeout(() => setCopiedError(false), 2000);
      if (onCopyError) {
        onCopyError(errorDetails.code, errorDetails.message);
      }
    } catch (err) {
      console.error("Failed to copy error to clipboard:", err);
    }
  };
  const containerStyle = isFullSlide ? {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    padding: theme2.space[4],
    margin: 0,
    overflow: "auto"
  } : isModalMode ? {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    padding: 0,
    margin: 0,
    overflow: "visible"
  } : {
    position: "relative",
    maxHeight: "400px",
    display: "block",
    backgroundColor: hasRendered ? theme2.colors.backgroundSecondary : theme2.colors.backgroundSecondary,
    border: hasRendered ? `1px solid ${theme2.colors.border}` : `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[2],
    padding: hasRendered ? theme2.space[3] : theme2.space[4],
    margin: `${theme2.space[4]}px 0`,
    overflowX: hasRendered ? "auto" : "visible",
    overflowY: hasRendered ? "auto" : "visible"
  };
  const placeholderStyle = {
    textAlign: "center",
    color: theme2.colors.textSecondary,
    fontSize: theme2.fontSizes[2],
    fontFamily: theme2.fonts.body
  };
  if (isModalMode || isFullSlide) {
    return /* @__PURE__ */ React5.createElement("div", {
      ref: containerRef,
      style: containerStyle,
      className: "mermaid-container"
    }, !hasRendered && /* @__PURE__ */ React5.createElement("div", {
      style: placeholderStyle
    }, /* @__PURE__ */ React5.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React5.createElement("div", {
      style: { fontSize: theme2.fontSizes[1], marginTop: theme2.space[2], opacity: 0.7 }
    }, "Loading...")), errorDetails && /* @__PURE__ */ React5.createElement("div", {
      style: {
        padding: theme2.space[4],
        background: `${theme2.colors.error}22`,
        border: `1px solid ${theme2.colors.error}`,
        borderRadius: theme2.radii[2],
        color: theme2.colors.text,
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[1],
        maxWidth: "600px",
        margin: "0 auto"
      }
    }, /* @__PURE__ */ React5.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: theme2.space[2]
      }
    }, /* @__PURE__ */ React5.createElement("div", {
      style: { fontWeight: theme2.fontWeights.bold }
    }, "Failed to render Mermaid diagram"), /* @__PURE__ */ React5.createElement("button", {
      onClick: handleCopyError,
      style: {
        padding: theme2.space[1],
        backgroundColor: copiedError ? theme2.colors.success : theme2.colors.backgroundSecondary,
        border: `1px solid ${copiedError ? theme2.colors.success : theme2.colors.border}`,
        borderRadius: theme2.radii[1],
        color: copiedError ? theme2.colors.background : theme2.colors.text,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: theme2.space[1],
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.body,
        transition: "all 0.2s ease"
      },
      title: "Copy error details"
    }, copiedError ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Check, {
      size: 14
    }), "Copied") : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Copy, {
      size: 14
    }), "Copy Error"))), /* @__PURE__ */ React5.createElement("div", {
      style: {
        fontSize: theme2.fontSizes[0],
        opacity: 0.8,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
      }
    }, errorDetails.message)));
  }
  return /* @__PURE__ */ React5.createElement("div", {
    style: { position: "relative", width: "100%" }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: { position: "relative", width: "100%" }
  }, hasRendered && !isModalMode && onExpandClick && !errorDetails && /* @__PURE__ */ React5.createElement("div", {
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      zIndex: 10,
      display: "flex",
      gap: theme2.space[1]
    }
  }, /* @__PURE__ */ React5.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onExpandClick();
    },
    style: {
      padding: theme2.space[1],
      backgroundColor: theme2.colors.backgroundSecondary,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.text,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "28px",
      height: "28px"
    },
    title: "View fullscreen"
  }, /* @__PURE__ */ React5.createElement(Expand, {
    size: 14
  }))), /* @__PURE__ */ React5.createElement("div", {
    ref: containerRef,
    style: containerStyle,
    className: "mermaid-container"
  }, !hasRendered && /* @__PURE__ */ React5.createElement("div", {
    style: placeholderStyle
  }, /* @__PURE__ */ React5.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React5.createElement("div", {
    style: { fontSize: theme2.fontSizes[1], marginTop: theme2.space[2], opacity: 0.7 }
  }, isIntersecting ? "Loading..." : "Scroll to view")), errorDetails && /* @__PURE__ */ React5.createElement("div", {
    style: {
      padding: theme2.space[4],
      background: `${theme2.colors.error}22`,
      border: `1px solid ${theme2.colors.error}`,
      borderRadius: theme2.radii[2],
      color: theme2.colors.text,
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1]
    }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: theme2.space[2]
    }
  }, /* @__PURE__ */ React5.createElement("div", {
    style: { fontWeight: theme2.fontWeights.bold }
  }, "Failed to render Mermaid diagram"), /* @__PURE__ */ React5.createElement("button", {
    onClick: handleCopyError,
    style: {
      padding: theme2.space[1],
      backgroundColor: copiedError ? theme2.colors.success : theme2.colors.backgroundSecondary,
      border: `1px solid ${copiedError ? theme2.colors.success : theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: copiedError ? theme2.colors.background : theme2.colors.text,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[1],
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    title: "Copy error details"
  }, copiedError ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Check, {
    size: 14
  }), "Copied") : /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Copy, {
    size: 14
  }), "Copy Error"))), /* @__PURE__ */ React5.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[0],
      opacity: 0.8,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word"
    }
  }, errorDetails.message)))));
}

// industryMarkdown/components/IndustryLazyMermaidDiagram.tsx
function IndustryLazyMermaidDiagram({
  code,
  id,
  onCopyError,
  rootMargin = "200px",
  onShowInPanel,
  theme: themeOverride,
  onExpandClick
}) {
  const theme2 = themeOverride ?? theme;
  const [isIntersecting, setIsIntersecting] = useState4(false);
  const [hasRendered, setHasRendered] = useState4(false);
  const [isMounted, setIsMounted] = useState4(false);
  const [hasError, setHasError] = useState4(false);
  const containerRef = useRef2(null);
  useEffect3(() => {
    setIsMounted(true);
  }, []);
  useEffect3(() => {
    if (!isMounted)
      return;
    if (typeof IntersectionObserver === "undefined") {
      setIsIntersecting(true);
      setHasRendered(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
      if (entry.isIntersecting && !hasRendered) {
        setHasRendered(true);
      }
    }, {
      rootMargin,
      threshold: 0.01
    });
    const currentElement = containerRef.current;
    if (currentElement && observer) {
      observer.observe(currentElement);
    }
    return () => {
      if (currentElement && observer) {
        observer.unobserve(currentElement);
      }
    };
  }, [rootMargin, hasRendered, isMounted]);
  const getPlaceholderStyle = () => {
    return {
      position: "relative",
      margin: `${theme2.space[4]}px 0`,
      padding: theme2.space[5],
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      backgroundColor: theme2.colors.backgroundSecondary,
      minHeight: "200px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
  };
  const getTextStyle = () => {
    return {
      textAlign: "center",
      fontSize: theme2.fontSizes[2],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    };
  };
  const getSecondaryTextStyle = () => {
    return {
      fontSize: theme2.fontSizes[1],
      marginTop: theme2.space[2],
      color: theme2.colors.textTertiary
    };
  };
  if (!isMounted) {
    return /* @__PURE__ */ React6.createElement("div", {
      style: getPlaceholderStyle()
    }, /* @__PURE__ */ React6.createElement("div", {
      style: getTextStyle()
    }, /* @__PURE__ */ React6.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React6.createElement("div", {
      style: getSecondaryTextStyle()
    }, "Loading...")));
  }
  return /* @__PURE__ */ React6.createElement("div", {
    ref: containerRef,
    style: { position: "relative", width: "100%" }
  }, hasRendered && onShowInPanel && !hasError && /* @__PURE__ */ React6.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      const titleMatch = code.match(/^(?:%%\s*(.+)|(\w+)\s)/m);
      const title = titleMatch?.[1] || titleMatch?.[2] || "Diagram from Markdown";
      onShowInPanel(code, title);
    },
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[1],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      zIndex: 10,
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[1]
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
    },
    title: "Show in diagram panel"
  }, /* @__PURE__ */ React6.createElement(MoveRight, {
    size: 14
  })), hasRendered ? /* @__PURE__ */ React6.createElement(IndustryMermaidDiagram, {
    code,
    id,
    onCopyError,
    onError: setHasError,
    theme: theme2,
    onExpandClick
  }) : /* @__PURE__ */ React6.createElement("div", {
    style: getPlaceholderStyle()
  }, /* @__PURE__ */ React6.createElement("div", {
    style: getTextStyle()
  }, /* @__PURE__ */ React6.createElement("div", null, "\uD83D\uDCCA Mermaid Diagram"), /* @__PURE__ */ React6.createElement("div", {
    style: getSecondaryTextStyle()
  }, isIntersecting ? "Loading..." : "Scroll to view"))));
}

// industryMarkdown/components/IndustryMarkdownComponents.tsx
import { Copy as Copy2, Monitor, FileText, Check as Check2 } from "lucide-react";
import React9, { useMemo, useState as useState6, useRef as useRef4 } from "react";

// industryMarkdown/utils/componentUtils.tsx
import React7 from "react";
var extractTextFromChildren = (children) => {
  if (typeof children === "string") {
    return children;
  }
  if (Array.isArray(children)) {
    return children.map(extractTextFromChildren).join("");
  }
  if (React7.isValidElement(children)) {
    const props = children.props;
    if (props.children) {
      return extractTextFromChildren(props.children);
    }
  }
  return "";
};
var LinkWithLoadingIndicator = ({ href, children, onClick, className }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(href, e);
    }
  };
  return /* @__PURE__ */ React7.createElement("a", {
    href,
    onClick: handleClick,
    className,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children);
};
// industryMarkdown/components/IndustryBashCommandDropdown.tsx
import { Play, ChevronDown } from "lucide-react";
import React8, { useState as useState5, useRef as useRef3, useEffect as useEffect4 } from "react";
var IndustryBashCommandDropdown = ({
  commands,
  allCommands,
  onRunCommand,
  darkMode: _darkMode,
  slideIdPrefix: _slideIdPrefix,
  theme: themeOverride
}) => {
  const [isOpen, setIsOpen] = useState5(false);
  const [isRunning, setIsRunning] = useState5(false);
  const dropdownRef = useRef3(null);
  const theme2 = themeOverride ?? theme;
  useEffect4(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleRunCommand = async (command) => {
    setIsRunning(true);
    setIsOpen(false);
    try {
      await onRunCommand(command);
    } finally {
      setIsRunning(false);
    }
  };
  const buttonStyle = {
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    backgroundColor: isRunning ? theme2.colors.muted : theme2.colors.primary,
    color: theme2.colors.background,
    border: "none",
    borderRadius: theme2.radii[1],
    fontSize: theme2.fontSizes[1],
    cursor: isRunning ? "not-allowed" : "pointer",
    display: "flex",
    alignItems: "center",
    gap: theme2.space[2],
    opacity: isRunning ? 0.6 : 1,
    minWidth: "70px",
    justifyContent: "center",
    fontFamily: theme2.fonts.body,
    fontWeight: theme2.fontWeights.medium,
    transition: "all 0.2s ease"
  };
  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    right: "0",
    backgroundColor: theme2.colors.background,
    border: `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[2],
    boxShadow: theme2.shadows[2],
    zIndex: 10,
    minWidth: "200px",
    maxWidth: "350px",
    maxHeight: "300px",
    overflow: "auto",
    marginTop: theme2.space[1]
  };
  const dropdownItemStyle = (isHovered) => ({
    padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
    cursor: "pointer",
    backgroundColor: isHovered ? theme2.colors.backgroundSecondary : "transparent",
    fontSize: theme2.fontSizes[1],
    color: theme2.colors.text,
    fontFamily: theme2.fonts.monospace,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    transition: "background-color 0.2s ease"
  });
  const hasMultipleCommands = commands.length > 1;
  const singleCommand = commands.length === 1 ? commands[0].command : allCommands;
  return /* @__PURE__ */ React8.createElement("div", {
    ref: dropdownRef,
    style: { position: "relative", display: "inline-block" }
  }, hasMultipleCommands ? /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement("button", {
    onClick: () => setIsOpen(!isOpen),
    disabled: isRunning,
    style: buttonStyle,
    onMouseEnter: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.secondary;
      }
    },
    onMouseLeave: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.primary;
      }
    }
  }, isRunning ? /* @__PURE__ */ React8.createElement("span", {
    style: { fontSize: theme2.fontSizes[1] }
  }, "...") : /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Play, {
    size: 14
  }), "Run", /* @__PURE__ */ React8.createElement(ChevronDown, {
    size: 14
  }))), isOpen && /* @__PURE__ */ React8.createElement("div", {
    style: dropdownStyle
  }, /* @__PURE__ */ React8.createElement("div", {
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      borderBottom: `1px solid ${theme2.colors.border}`,
      fontWeight: theme2.fontWeights.semibold,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, "Select command to run"), /* @__PURE__ */ React8.createElement("div", {
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.muted,
      cursor: "pointer",
      fontSize: theme2.fontSizes[1],
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      transition: "background-color 0.2s ease"
    },
    onClick: () => handleRunCommand(allCommands),
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.muted;
    }
  }, "\uD83D\uDE80 Run all (", commands.length, " commands)"), commands.map((cmd, index) => {
    const [isHovered, setIsHovered] = useState5(false);
    return /* @__PURE__ */ React8.createElement("div", {
      key: index,
      style: dropdownItemStyle(isHovered),
      onClick: () => handleRunCommand(cmd.command),
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      title: cmd.command
    }, getCommandDisplayName(cmd));
  }))) : /* @__PURE__ */ React8.createElement("button", {
    onClick: () => handleRunCommand(singleCommand),
    disabled: isRunning,
    style: buttonStyle,
    onMouseEnter: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.secondary;
      }
    },
    onMouseLeave: (e) => {
      if (!isRunning) {
        e.currentTarget.style.backgroundColor = theme2.colors.primary;
      }
    }
  }, isRunning ? /* @__PURE__ */ React8.createElement("span", {
    style: { fontSize: theme2.fontSizes[1] }
  }, "...") : /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Play, {
    size: 14
  }), "Run")));
};

// industryMarkdown/components/IndustryMarkdownComponents.tsx
var failedImageCache = new Set;
var isVideoUrl = (url, alt) => {
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv", ".m4v"];
  const lowercaseUrl = url.toLowerCase();
  if (videoExtensions.some((ext) => lowercaseUrl.includes(ext))) {
    return true;
  }
  if (alt) {
    const altLower = alt.toLowerCase();
    if (altLower.includes("video") || altLower.includes("demo") || altLower.includes("recording")) {
      return true;
    }
  }
  return false;
};
var OptimizedMarkdownMedia = React9.memo(({
  src,
  alt,
  repositoryInfo,
  theme: theme2,
  ...props
}) => {
  const transformedSrc = useMemo(() => {
    return transformImageUrl(src, repositoryInfo);
  }, [src, repositoryInfo]);
  const [hasErrored, setHasErrored] = useState6(() => failedImageCache.has(transformedSrc));
  const retryCount = useRef4(0);
  const mediaStyle = useMemo(() => ({
    maxWidth: "100%",
    height: "auto",
    display: "block",
    margin: `${theme2.space[3]}px auto`,
    borderRadius: theme2.radii[1],
    boxShadow: theme2.shadows[2]
  }), [theme2]);
  const handleLoad = () => {
    failedImageCache.delete(transformedSrc);
    setHasErrored(false);
    retryCount.current = 0;
  };
  const handleError = (e) => {
    retryCount.current += 1;
    failedImageCache.add(transformedSrc);
    setHasErrored(true);
    e.stopPropagation();
  };
  if (isVideoUrl(transformedSrc, alt)) {
    if (hasErrored) {
      return /* @__PURE__ */ React9.createElement("span", {
        style: {
          ...mediaStyle,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme2.colors.backgroundSecondary,
          color: theme2.colors.textSecondary,
          border: `1px solid ${theme2.colors.border}`,
          padding: theme2.space[4],
          minHeight: "200px"
        }
      }, "⚠️ Video failed to load: ", alt || transformedSrc);
    }
    return /* @__PURE__ */ React9.createElement("video", {
      controls: true,
      style: mediaStyle,
      onLoadedData: handleLoad,
      onError: handleError,
      title: alt,
      ...props
    }, /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc
    }), /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc,
      type: "video/mp4"
    }), /* @__PURE__ */ React9.createElement("source", {
      src: transformedSrc,
      type: "video/webm"
    }), "Your browser does not support the video tag.");
  }
  const handleImageError = (e) => {
    retryCount.current += 1;
    failedImageCache.add(transformedSrc);
    setHasErrored(true);
    e.stopPropagation();
  };
  if (hasErrored) {
    return /* @__PURE__ */ React9.createElement("span", {
      style: {
        ...mediaStyle,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme2.colors.backgroundSecondary,
        color: theme2.colors.textSecondary,
        border: `1px solid ${theme2.colors.border}`,
        minHeight: "50px",
        minWidth: "100px",
        fontSize: theme2.fontSizes[0],
        textAlign: "center",
        padding: `${theme2.space[2]}px`
      },
      title: `Failed to load image: ${transformedSrc}`
    }, "\uD83D\uDDBC️ Image unavailable", " ", alt && /* @__PURE__ */ React9.createElement("span", {
      style: { fontSize: theme2.fontSizes[0], opacity: 0.7 }
    }, "(", alt, ")"));
  }
  return /* @__PURE__ */ React9.createElement("img", {
    src: transformedSrc,
    alt,
    style: mediaStyle,
    onLoad: handleLoad,
    onError: handleImageError,
    ...props
  });
});
var createIndustryMarkdownComponents = ({
  theme: theme2,
  slideIdPrefix,
  slideIndex,
  onLinkClick,
  onCheckboxChange,
  checkedItems,
  setCheckedItems,
  openHtmlModal,
  openPlaceholderModal,
  handleRunBashCommand,
  enableHtmlPopout,
  slideHeaderMarginTopOverride,
  index,
  repositoryInfo,
  editable = false
}) => {
  const getLuminance = (hex) => {
    const rgb = hex.replace("#", "").match(/.{2}/g);
    if (!rgb)
      return 1;
    const [r, g, b] = rgb.map((x) => parseInt(x, 16) / 255);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };
  const darkMode = getLuminance(theme2.colors.background) < 0.5;
  const headerStyles = {};
  if (index === 0) {
    headerStyles.marginTop = slideHeaderMarginTopOverride ? `${slideHeaderMarginTopOverride}px` : 0;
  }
  return {
    h1: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h1", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[5],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.bold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[4],
        fontFamily: theme2.fonts.heading,
        paddingBottom: theme2.space[2],
        borderBottom: `1px solid ${theme2.colors.border}`,
        ...headerStyles
      },
      ...props
    }, children),
    h2: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h2", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[4],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.bold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.heading,
        paddingBottom: theme2.space[2],
        borderBottom: `1px solid ${theme2.colors.border}`,
        ...headerStyles
      },
      ...props
    }, children),
    h3: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h3", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[3],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[4],
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h4: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h4", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[2],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h5: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h5", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.semibold,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[1],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    h6: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("h6", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        lineHeight: theme2.lineHeights.heading,
        fontWeight: theme2.fontWeights.medium,
        marginTop: theme2.space[3],
        marginBottom: theme2.space[1],
        fontFamily: theme2.fonts.heading
      },
      ...props
    }, children),
    p: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("p", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    ul: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("ul", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        paddingLeft: theme2.space[5],
        listStyleType: "disc",
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    ol: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("ol", {
      style: {
        color: theme2.colors.text,
        fontSize: theme2.fontSizes[2],
        lineHeight: theme2.lineHeights.body,
        marginBottom: theme2.space[3],
        paddingLeft: theme2.space[5],
        listStyleType: "decimal",
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children),
    li: ({ children, ...props }) => {
      const isTaskListItem = Array.isArray(children) && children.length > 0 && React9.isValidElement(children[0]) && children[0]?.props?.type === "checkbox";
      if (isTaskListItem) {
        const checkbox = children[0];
        const remainingChildren = children.slice(1);
        const labelContent = [];
        const nestedListElements = [];
        React9.Children.forEach(remainingChildren, (child) => {
          if (React9.isValidElement(child) && (child.type === "ul" || child.type === "ol")) {
            nestedListElements.push(child);
          } else {
            labelContent.push(child);
          }
        });
        const checked = checkbox?.props?.checked || false;
        const lineNumber = props.sourcePosition?.start?.line || props.node?.position?.start?.line || 1;
        const id = `${slideIdPrefix}-checkbox-${lineNumber}`;
        const isChecked = checkedItems[id] ?? checked;
        const handleChange = (e) => {
          e.stopPropagation();
          const newChecked = e.target.checked;
          setCheckedItems((prev) => ({
            ...prev,
            [id]: newChecked
          }));
          onCheckboxChange?.(slideIndex, lineNumber, newChecked);
        };
        return /* @__PURE__ */ React9.createElement("li", {
          style: {
            listStyle: "none",
            marginLeft: `-${theme2.space[5]}px`,
            marginBottom: theme2.space[3],
            paddingTop: theme2.space[1],
            color: theme2.colors.text,
            fontSize: theme2.fontSizes[2]
          },
          ...props
        }, /* @__PURE__ */ React9.createElement("div", {
          style: { display: "flex", alignItems: "flex-start" }
        }, /* @__PURE__ */ React9.createElement("input", {
          type: "checkbox",
          checked: isChecked,
          onChange: handleChange,
          onClick: (e) => e.stopPropagation(),
          disabled: !editable,
          style: {
            marginRight: theme2.space[2],
            marginTop: theme2.space[1],
            width: "16px",
            height: "16px",
            cursor: editable ? "pointer" : "default"
          },
          id
        }), /* @__PURE__ */ React9.createElement("label", {
          htmlFor: id,
          style: {
            flex: 1,
            cursor: editable ? "pointer" : "default",
            color: isChecked ? theme2.colors.textMuted : "inherit",
            lineHeight: theme2.lineHeights.relaxed
          }
        }, labelContent.length > 0 ? labelContent : null)), nestedListElements.length > 0 ? nestedListElements : null);
      }
      return /* @__PURE__ */ React9.createElement("li", {
        style: {
          marginBottom: theme2.space[2],
          paddingTop: theme2.space[1],
          color: theme2.colors.text,
          lineHeight: theme2.lineHeights.relaxed
        },
        ...props
      }, children);
    },
    table: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("div", {
      style: {
        overflowX: "auto",
        marginBottom: theme2.space[4],
        borderRadius: theme2.radii[2],
        border: `1px solid ${theme2.colors.border}`
      }
    }, /* @__PURE__ */ React9.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse",
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body
      },
      ...props
    }, children)),
    thead: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("thead", {
      style: {
        backgroundColor: theme2.colors.backgroundSecondary
      },
      ...props
    }, children),
    th: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("th", {
      style: {
        padding: theme2.space[3],
        textAlign: "left",
        fontWeight: theme2.fontWeights.semibold,
        borderBottom: `2px solid ${theme2.colors.border}`,
        color: theme2.colors.text
      },
      ...props
    }, children),
    td: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("td", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        color: theme2.colors.text
      },
      ...props
    }, children),
    a: ({ children, href, ...props }) => /* @__PURE__ */ React9.createElement(LinkWithLoadingIndicator, {
      href: href || "",
      onClick: onLinkClick ? (h, e) => onLinkClick(h, e) : undefined,
      className: props.className
    }, children),
    img: ({ src, alt, ...props }) => /* @__PURE__ */ React9.createElement(OptimizedMarkdownMedia, {
      src: src || "",
      alt: alt || "",
      repositoryInfo,
      theme: theme2,
      ...props
    }),
    picture: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("picture", {
      ...props
    }, children),
    video: ({ children, ...props }) => /* @__PURE__ */ React9.createElement("video", {
      controls: true,
      style: {
        maxWidth: "100%",
        height: "auto",
        display: "block",
        margin: `${theme2.space[3]}px auto`,
        borderRadius: theme2.radii[1],
        boxShadow: theme2.shadows[2]
      },
      ...props
    }, children),
    source: ({ srcset, srcSet, ...props }) => {
      const srcsetValue = srcset || srcSet;
      const transformedSrcset = useMemo(() => {
        if (!srcsetValue || !repositoryInfo)
          return srcsetValue;
        return srcsetValue.split(",").map((src) => {
          const trimmed = src.trim();
          const parts = trimmed.split(/\s+/);
          const url = parts[0];
          const descriptors = parts.slice(1).join(" ");
          const transformedUrl = transformImageUrl(url, repositoryInfo);
          return descriptors ? `${transformedUrl} ${descriptors}` : transformedUrl;
        }).join(", ");
      }, [srcsetValue, repositoryInfo]);
      return /* @__PURE__ */ React9.createElement("source", {
        srcSet: transformedSrcset,
        ...props
      });
    },
    code: ({ node, className, children, ...props }) => {
      const hasLanguageClass = className && (className.includes("language-") || className.includes("hljs"));
      const codeString = extractTextFromChildren(children);
      const matchLang = /language-(\w+)/.exec(className || "");
      const language = matchLang ? matchLang[1] : null;
      const [copied, setCopied] = useState6(false);
      let isInline;
      let isCodeBlock;
      const hasNewlines = codeString.includes(`
`);
      if (!className && !hasNewlines) {
        isInline = true;
        isCodeBlock = false;
      } else if (hasNewlines) {
        isInline = false;
        isCodeBlock = true;
      } else if (language === "text") {
        isInline = true;
        isCodeBlock = false;
      } else {
        isCodeBlock = hasLanguageClass || codeString.length > 50;
        const nodeWithParent = node;
        const isInsideParagraph = nodeWithParent?.parent?.tagName === "p" || nodeWithParent?.parent?.parent?.tagName === "p";
        isInline = !isCodeBlock || isInsideParagraph;
      }
      if (!isInline) {
        const language2 = matchLang ? matchLang[1] : "text";
        const isExecutable = (language2 === "bash" || language2 === "sh" || language2 === "shell") && handleRunBashCommand;
        const isHtml = (language2 === "html" || language2 === "htm") && enableHtmlPopout;
        const isPrompt = language2 === "prompt";
        const placeholderRegex = /\{\{([^}]+)\}\}/g;
        const placeholders = isPrompt ? [...codeString.matchAll(placeholderRegex)].map((match) => match[1].trim()) : [];
        const hasPlaceholders = placeholders.length > 0;
        const bashCommands = isExecutable ? parseBashCommands(codeString) : [];
        const containerStyle = isPrompt ? {
          position: "relative",
          backgroundColor: darkMode ? theme2.colors.backgroundTertiary : theme2.colors.highlight,
          border: `2px solid ${theme2.colors.accent}`,
          borderRadius: theme2.radii[2],
          overflow: "visible",
          boxShadow: theme2.shadows[2],
          marginTop: `${theme2.space[2]}px`,
          marginBottom: `${theme2.space[3]}px`
        } : {
          position: "relative",
          backgroundColor: theme2.colors.backgroundSecondary,
          borderRadius: theme2.radii[2],
          overflow: "hidden",
          border: `1px solid ${theme2.colors.border}`,
          marginTop: `${theme2.space[2]}px`,
          marginBottom: `${theme2.space[3]}px`
        };
        const headerStyle = isPrompt ? {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: `${theme2.space[3]}px ${theme2.space[4]}px`,
          backgroundColor: theme2.colors.muted,
          borderBottom: `2px solid ${theme2.colors.accent}`,
          fontSize: theme2.fontSizes[0],
          color: theme2.colors.accent
        } : {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          backgroundColor: theme2.colors.backgroundTertiary,
          borderBottom: `1px solid ${theme2.colors.border}`,
          fontSize: theme2.fontSizes[0]
        };
        return /* @__PURE__ */ React9.createElement("div", {
          style: containerStyle
        }, /* @__PURE__ */ React9.createElement("div", {
          style: headerStyle
        }, /* @__PURE__ */ React9.createElement("span", {
          style: {
            fontFamily: theme2.fonts.monospace,
            fontWeight: isPrompt ? theme2.fontWeights.bold : theme2.fontWeights.body
          }
        }, isPrompt ? "\uD83D\uDCA1 Prompt" : language2), /* @__PURE__ */ React9.createElement("div", {
          style: { display: "flex", gap: `${theme2.space[2]}px` }
        }, /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            navigator.clipboard.writeText(codeString).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }).catch((err) => {
              console.error("Failed to copy:", err);
            });
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: copied ? theme2.colors.success + "22" : darkMode ? theme2.colors.backgroundTertiary : theme2.colors.backgroundSecondary,
            color: copied ? theme2.colors.success : theme2.colors.textSecondary,
            border: `1px solid ${copied ? theme2.colors.success : theme2.colors.border}`,
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`,
            transition: "all 0.15s ease-in-out"
          },
          title: copied ? "Copied!" : "Copy code to clipboard"
        }, copied ? /* @__PURE__ */ React9.createElement(Check2, {
          size: 14
        }) : /* @__PURE__ */ React9.createElement(Copy2, {
          size: 14
        }), copied ? "Copied!" : "Copy"), isExecutable && /* @__PURE__ */ React9.createElement(IndustryBashCommandDropdown, {
          commands: bashCommands,
          allCommands: codeString.trim(),
          onRunCommand: async (command) => {
            try {
              await handleRunBashCommand(command, {
                id: `${slideIdPrefix}-code-${Date.now()}`,
                showInTerminal: true
              });
            } catch (error) {
              console.error("Error running bash command:", error);
            }
          },
          slideIdPrefix,
          theme: theme2
        }), isHtml && /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            openHtmlModal(codeString);
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: theme2.colors.primary,
            color: "white",
            border: "none",
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`
          },
          title: "Render HTML in modal"
        }, /* @__PURE__ */ React9.createElement(Monitor, {
          size: 14
        }), "Render HTML"), isPrompt && openPlaceholderModal && hasPlaceholders && /* @__PURE__ */ React9.createElement("button", {
          onClick: (e) => {
            e.stopPropagation();
            openPlaceholderModal(placeholders, codeString);
          },
          style: {
            padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
            backgroundColor: theme2.colors.accent,
            color: "white",
            border: "none",
            borderRadius: theme2.radii[1],
            fontSize: theme2.fontSizes[0],
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: `${theme2.space[1]}px`
          },
          title: "Fill placeholders and copy"
        }, /* @__PURE__ */ React9.createElement(FileText, {
          size: 14
        }), "Fill & Copy (", placeholders.length, ")"))), isPrompt ? /* @__PURE__ */ React9.createElement("div", {
          style: {
            margin: 0,
            padding: theme2.space[1],
            backgroundColor: "transparent",
            fontSize: theme2.fontSizes[1],
            lineHeight: theme2.lineHeights.body,
            fontFamily: theme2.fonts.body,
            overflow: "auto",
            color: theme2.colors.text
          }
        }, codeString.split(/(\{\{[^}]+\}\})/).map((part, index2) => {
          if (part.match(/^\{\{[^}]+\}\}$/)) {
            return /* @__PURE__ */ React9.createElement("span", {
              key: index2,
              style: {
                backgroundColor: theme2.colors.highlight,
                color: theme2.colors.primary,
                padding: `${theme2.space[0]}px ${theme2.space[1]}px`,
                borderRadius: theme2.radii[1],
                fontWeight: theme2.fontWeights.semibold,
                fontFamily: theme2.fonts.monospace,
                fontSize: theme2.fontSizes[1]
              }
            }, part);
          }
          return part;
        })) : /* @__PURE__ */ React9.createElement("pre", {
          style: {
            margin: 0,
            padding: theme2.space[1],
            backgroundColor: "transparent",
            overflow: "auto",
            fontSize: theme2.fontSizes[1],
            lineHeight: 1.2,
            fontFamily: theme2.fonts.monospace
          }
        }, /* @__PURE__ */ React9.createElement("code", {
          className,
          style: {
            lineHeight: "inherit",
            fontSize: "inherit",
            fontFamily: "inherit",
            display: "block"
          },
          ...props
        }, children)));
      }
      const cleanClassName = className?.replace(/hljs(-\w+)?/g, "")?.replace(/language-\w+/g, "")?.replace(/\s+/g, " ")?.trim();
      return /* @__PURE__ */ React9.createElement("code", {
        style: {
          color: theme2.colors.accent,
          fontSize: "0.875em",
          fontFamily: theme2.fonts.monospace,
          backgroundColor: "transparent",
          padding: 0,
          "--text-color": theme2.colors.accent
        },
        className: cleanClassName ? `inline-code ${cleanClassName}` : "inline-code",
        ...props
      }, children);
    }
  };
};

// industryMarkdown/components/IndustryMermaidModal.tsx
import React11, { useEffect as useEffect6, useRef as useRef6 } from "react";
import { createPortal } from "react-dom";

// industryMarkdown/components/IndustryZoomableMermaidDiagram.tsx
import React10, { useEffect as useEffect5, useRef as useRef5, useState as useState7 } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
function IndustryZoomableMermaidDiagram({
  code,
  id,
  theme: themeOverride,
  fitStrategy = "contain",
  padding = 0.9
}) {
  const theme2 = themeOverride ?? theme;
  const [calculatedScale, setCalculatedScale] = useState7(1);
  const [hasInitialized, setHasInitialized] = useState7(false);
  const containerRef = useRef5(null);
  const diagramRef = useRef5(null);
  const [isCalculating, setIsCalculating] = useState7(true);
  const transformRef = useRef5(null);
  useEffect5(() => {
    if (!containerRef.current || !diagramRef.current)
      return;
    const calculateOptimalScale = () => {
      const container = containerRef.current;
      const diagram = diagramRef.current;
      if (!container || !diagram)
        return;
      const svg = diagram.querySelector("svg");
      if (!svg) {
        setTimeout(calculateOptimalScale, 100);
        return;
      }
      let svgWidth, svgHeight;
      const viewBox = svg.getAttribute("viewBox");
      if (viewBox) {
        const [, , width, height] = viewBox.split(" ").map(Number);
        svgWidth = width;
        svgHeight = height;
      } else {
        const explicitWidth = svg.getAttribute("width");
        const explicitHeight = svg.getAttribute("height");
        if (explicitWidth && explicitHeight) {
          svgWidth = parseFloat(explicitWidth);
          svgHeight = parseFloat(explicitHeight);
        } else {
          const svgRect = svg.getBoundingClientRect();
          svgWidth = svgRect.width;
          svgHeight = svgRect.height;
        }
      }
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      if (svgWidth <= 0 || svgHeight <= 0 || containerWidth <= 0 || containerHeight <= 0) {
        return;
      }
      let scale = 1;
      switch (fitStrategy) {
        case "width":
          scale = containerWidth * padding / svgWidth;
          break;
        case "height":
          scale = containerHeight * padding / svgHeight;
          break;
        case "contain":
        default:
          scale = Math.min(containerWidth * padding / svgWidth, containerHeight * padding / svgHeight);
          break;
      }
      scale = Math.min(Math.max(scale, 0.3), 3);
      setCalculatedScale(scale);
      setHasInitialized(true);
      setIsCalculating(false);
    };
    const resizeObserver = new ResizeObserver(() => {
      calculateOptimalScale();
    });
    resizeObserver.observe(containerRef.current);
    setTimeout(calculateOptimalScale, 100);
    setTimeout(calculateOptimalScale, 500);
    return () => {
      resizeObserver.disconnect();
    };
  }, [code, fitStrategy, padding]);
  useEffect5(() => {
    if (hasInitialized && transformRef.current) {
      const { centerView } = transformRef.current;
      centerView(calculatedScale, 0, "easeOut");
    }
  }, [hasInitialized, calculatedScale]);
  const buttonStyle = {
    padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
    marginRight: theme2.space[2],
    backgroundColor: theme2.colors.background,
    color: theme2.colors.text,
    border: `1px solid ${theme2.colors.border}`,
    borderRadius: theme2.radii[1],
    fontSize: theme2.fontSizes[2],
    fontWeight: theme2.fontWeights.medium,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: theme2.fonts.body
  };
  const handleButtonHover = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
  };
  const handleButtonLeave = (e) => {
    e.currentTarget.style.backgroundColor = theme2.colors.background;
  };
  return /* @__PURE__ */ React10.createElement("div", {
    ref: containerRef,
    style: {
      width: "100%",
      height: "100%",
      position: "relative",
      backgroundColor: theme2.colors.background
    }
  }, /* @__PURE__ */ React10.createElement(TransformWrapper, {
    limitToBounds: true,
    doubleClick: { disabled: true },
    minScale: 0.1,
    maxScale: 10,
    initialScale: 1,
    initialPositionX: 0,
    initialPositionY: 0,
    centerOnInit: true,
    centerZoomedOut: true,
    alignmentAnimation: { disabled: true },
    zoomAnimation: { disabled: false, size: 0.2 }
  }, ({ centerView, instance }) => {
    transformRef.current = { centerView, instance };
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement("div", {
      style: {
        position: "absolute",
        top: theme2.space[3],
        right: theme2.space[3],
        zIndex: 10,
        display: "flex",
        gap: theme2.space[2]
      }
    }, /* @__PURE__ */ React10.createElement("button", {
      onClick: () => {
        centerView(calculatedScale, 200, "easeOut");
      },
      style: buttonStyle,
      onMouseEnter: handleButtonHover,
      onMouseLeave: handleButtonLeave,
      title: "Reset view"
    }, "⟲"), isCalculating && /* @__PURE__ */ React10.createElement("span", {
      style: {
        padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
        fontSize: theme2.fontSizes[1],
        color: theme2.colors.textMuted,
        fontFamily: theme2.fonts.body
      }
    }, "Optimizing view...")), /* @__PURE__ */ React10.createElement(TransformComponent, {
      wrapperStyle: {
        width: "100%",
        height: "100%",
        backgroundColor: theme2.colors.background,
        overflow: "hidden"
      },
      contentStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /* @__PURE__ */ React10.createElement("div", {
      ref: diagramRef,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%"
      }
    }, /* @__PURE__ */ React10.createElement(IndustryMermaidDiagram, {
      code,
      id,
      isModalMode: true,
      theme: theme2
    }))));
  }));
}

// industryMarkdown/components/IndustryMermaidModal.tsx
function IndustryMermaidModal({
  isOpen,
  onClose,
  mermaidCode,
  theme: theme2
}) {
  const modalRef = useRef6(null);
  useEffect6(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  if (!isOpen) {
    return null;
  }
  const modalContent = /* @__PURE__ */ React11.createElement("div", {
    onClick: handleBackdropClick,
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 50,
      padding: theme2.space[4]
    }
  }, /* @__PURE__ */ React11.createElement("div", {
    ref: modalRef,
    onClick: (e) => e.stopPropagation(),
    style: {
      position: "relative",
      backgroundColor: theme2.colors.background,
      borderRadius: theme2.radii[3],
      padding: 0,
      width: "95vw",
      height: "95vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: theme2.shadows[4]
    }
  }, /* @__PURE__ */ React11.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: {
      position: "absolute",
      top: theme2.space[2],
      right: theme2.space[2],
      zIndex: 100,
      background: theme2.colors.background,
      border: `1px solid ${theme2.colors.border}`,
      fontSize: theme2.fontSizes[4],
      color: theme2.colors.text,
      cursor: "pointer",
      lineHeight: 1,
      padding: `${theme2.space[1]}px`,
      borderRadius: theme2.radii[1],
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
      e.currentTarget.style.color = theme2.colors.text;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
      e.currentTarget.style.color = theme2.colors.text;
    },
    "aria-label": "Close"
  }, "×"), /* @__PURE__ */ React11.createElement("div", {
    style: {
      flex: 1,
      overflow: "hidden",
      position: "relative",
      backgroundColor: theme2.colors.background,
      padding: `${theme2.space[5]}px ${theme2.space[2]}px ${theme2.space[2]}px ${theme2.space[2]}px`
    }
  }, /* @__PURE__ */ React11.createElement(IndustryZoomableMermaidDiagram, {
    id: "mermaid-modal-diagram",
    code: mermaidCode,
    theme: theme2
  }))));
  return createPortal(modalContent, document.body);
}

// industryMarkdown/components/IndustryPlaceholderModal.tsx
import React12, { useState as useState8 } from "react";
function IndustryPlaceholderModal({
  isOpen,
  onClose,
  placeholders,
  promptContent,
  onCopy,
  theme: theme2
}) {
  const [values, setValues] = useState8({});
  if (!isOpen)
    return null;
  const handleSubmit = (e) => {
    e.preventDefault();
    let filledPrompt = promptContent;
    placeholders.forEach((placeholder) => {
      const value = values[placeholder] || `{{${placeholder}}}`;
      const regex = new RegExp(`\\{\\{${placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\}\\}`, "g");
      filledPrompt = filledPrompt.replace(regex, value);
    });
    navigator.clipboard.writeText(filledPrompt).then(() => {
      onCopy(filledPrompt);
      onClose();
      setValues({});
    }).catch((err) => {
      console.error("Failed to copy filled prompt:", err);
    });
  };
  return /* @__PURE__ */ React12.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 50,
      padding: theme2.space[5]
    },
    onClick: onClose
  }, /* @__PURE__ */ React12.createElement("div", {
    style: {
      backgroundColor: theme2.colors.background,
      borderRadius: theme2.radii[3],
      maxWidth: "600px",
      width: "100%",
      maxHeight: "80vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      border: `1px solid ${theme2.colors.border}`,
      boxShadow: theme2.shadows[4]
    },
    onClick: (e) => e.stopPropagation()
  }, /* @__PURE__ */ React12.createElement("div", {
    style: {
      padding: theme2.space[4],
      borderBottom: `1px solid ${theme2.colors.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: theme2.colors.backgroundSecondary
    }
  }, /* @__PURE__ */ React12.createElement("h3", {
    style: {
      margin: 0,
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[3],
      fontWeight: theme2.fontWeights.semibold,
      fontFamily: theme2.fonts.heading
    }
  }, "Fill Prompt Placeholders"), /* @__PURE__ */ React12.createElement("button", {
    onClick: (e) => {
      e.stopPropagation();
      onClose();
    },
    style: {
      background: "none",
      border: "none",
      fontSize: theme2.fontSizes[5],
      cursor: "pointer",
      color: theme2.colors.textSecondary,
      padding: `${theme2.space[1]}px`,
      borderRadius: theme2.radii[1],
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundTertiary;
      e.currentTarget.style.color = theme2.colors.text;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.color = theme2.colors.textSecondary;
    },
    title: "Close",
    "aria-label": "Close modal"
  }, "×")), /* @__PURE__ */ React12.createElement("div", {
    style: {
      padding: theme2.space[5],
      overflow: "auto",
      flex: 1,
      backgroundColor: theme2.colors.background
    }
  }, /* @__PURE__ */ React12.createElement("p", {
    style: {
      margin: `0 0 ${theme2.space[4]}px 0`,
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[2],
      lineHeight: theme2.lineHeights.body,
      fontFamily: theme2.fonts.body
    }
  }, "Fill in the values for the placeholders below. The prompt will be copied to your clipboard with the values substituted."), /* @__PURE__ */ React12.createElement("form", {
    onSubmit: handleSubmit
  }, placeholders.map((placeholder, index) => /* @__PURE__ */ React12.createElement("div", {
    key: index,
    style: { marginBottom: theme2.space[4] }
  }, /* @__PURE__ */ React12.createElement("label", {
    style: {
      display: "block",
      marginBottom: theme2.space[2],
      fontWeight: theme2.fontWeights.medium,
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body
    }
  }, placeholder), /* @__PURE__ */ React12.createElement("input", {
    type: "text",
    value: values[placeholder] || "",
    onChange: (e) => setValues((prev) => ({
      ...prev,
      [placeholder]: e.target.value
    })),
    style: {
      width: "100%",
      padding: `${theme2.space[3]}px`,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      outline: "none",
      fontFamily: theme2.fonts.body,
      transition: "border-color 0.2s ease"
    },
    onFocus: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.primary;
    },
    onBlur: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.border;
    },
    placeholder: `Enter value for ${placeholder}`
  }))), /* @__PURE__ */ React12.createElement("div", {
    style: {
      display: "flex",
      gap: theme2.space[3],
      justifyContent: "flex-end",
      marginTop: theme2.space[5]
    }
  }, /* @__PURE__ */ React12.createElement("button", {
    type: "button",
    onClick: onClose,
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[4]}px`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      border: `1px solid ${theme2.colors.border}`,
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2],
      backgroundColor: theme2.colors.background,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundSecondary;
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.background;
    }
  }, "Cancel"), /* @__PURE__ */ React12.createElement("button", {
    type: "submit",
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[4]}px`,
      borderRadius: theme2.radii[1],
      fontSize: theme2.fontSizes[2],
      fontWeight: theme2.fontWeights.medium,
      cursor: "pointer",
      border: "none",
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2],
      backgroundColor: theme2.colors.primary,
      color: "white",
      fontFamily: theme2.fonts.body,
      transition: "all 0.2s ease"
    },
    onMouseEnter: (e) => {
      e.currentTarget.style.opacity = "0.9";
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.opacity = "1";
    }
  }, "Copy to Clipboard"))))));
}

// industryMarkdown/components/IndustryMarkdownSlide.tsx
var highlightOverrides = `
  /* Override root .hljs class with maximum specificity */
  .markdown-slide .hljs,
  .markdown-slide pre .hljs,
  .markdown-slide code.hljs,
  .markdown-slide pre code.hljs {
    color: inherit !important;
    background: transparent !important;
    background-color: transparent !important;
  }


  /* Remove backgrounds from all highlight.js classes in code blocks */
  pre code .hljs,
  pre code .hljs-keyword,
  pre code .hljs-selector-tag,
  pre code .hljs-literal,
  pre code .hljs-strong,
  pre code .hljs-name,
  pre code .hljs-variable,
  pre code .hljs-number,
  pre code .hljs-string,
  pre code .hljs-comment,
  pre code .hljs-type,
  pre code .hljs-built_in,
  pre code .hljs-builtin-name,
  pre code .hljs-meta,
  pre code .hljs-tag,
  pre code .hljs-title,
  pre code .hljs-attr,
  pre code .hljs-attribute,
  pre code .hljs-addition,
  pre code .hljs-deletion,
  pre code .hljs-link,
  pre code .hljs-doctag,
  pre code .hljs-formula,
  pre code .hljs-section,
  pre code .hljs-selector-class,
  pre code .hljs-selector-attr,
  pre code .hljs-selector-pseudo,
  pre code .hljs-symbol,
  pre code .hljs-bullet,
  pre code .hljs-selector-id,
  pre code .hljs-emphasis,
  pre code .hljs-quote,
  pre code .hljs-template-variable,
  pre code .hljs-regexp,
  pre code .hljs-subst {
    background-color: transparent !important;
  }

  /* Aggressive removal of backgrounds and padding for inline code */
  p code,
  li code,
  td code,
  th code,
  h1 code,
  h2 code,
  h3 code,
  h4 code,
  h5 code,
  h6 code,
  blockquote code,
  .inline-code,
  code:not(pre code) {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--text-color, currentColor) !important;
  }

  /* Ensure inline code uses its own color even with hljs classes */
  .inline-code,
  .inline-code[class*="hljs"],
  .inline-code[class*="language"] {
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
  }

  /* Override any highlight.js styles on inline code */
  p code[class*="hljs"],
  li code[class*="hljs"],
  td code[class*="hljs"],
  th code[class*="hljs"],
  p code[class*="language"],
  li code[class*="language"],
  td code[class*="language"],
  th code[class*="language"] {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--text-color) !important;
  }

  /* Remove all hljs styling from any inline code - comprehensive override */
  :not(pre) > code.hljs,
  :not(pre) > code[class*="hljs"],
  :not(pre) > code[class*="language"] {
    all: unset !important;
    font-family: var(--monospace-font-family, monospace) !important;
    font-size: 0.875em !important;
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  /* Override all possible hljs token classes for inline code */
  :not(pre) > code .hljs-keyword,
  :not(pre) > code .hljs-selector-tag,
  :not(pre) > code .hljs-literal,
  :not(pre) > code .hljs-strong,
  :not(pre) > code .hljs-name,
  :not(pre) > code .hljs-variable,
  :not(pre) > code .hljs-number,
  :not(pre) > code .hljs-string,
  :not(pre) > code .hljs-comment,
  :not(pre) > code .hljs-type,
  :not(pre) > code .hljs-built_in,
  :not(pre) > code .hljs-builtin-name,
  :not(pre) > code .hljs-meta,
  :not(pre) > code .hljs-tag,
  :not(pre) > code .hljs-title,
  :not(pre) > code .hljs-attr,
  :not(pre) > code .hljs-attribute,
  :not(pre) > code .hljs-addition,
  :not(pre) > code .hljs-deletion,
  :not(pre) > code .hljs-link,
  :not(pre) > code .hljs-doctag,
  :not(pre) > code .hljs-formula,
  :not(pre) > code .hljs-section,
  :not(pre) > code .hljs-selector-class,
  :not(pre) > code .hljs-selector-attr,
  :not(pre) > code .hljs-selector-pseudo,
  :not(pre) > code .hljs-symbol,
  :not(pre) > code .hljs-bullet,
  :not(pre) > code .hljs-selector-id,
  :not(pre) > code .hljs-emphasis,
  :not(pre) > code .hljs-quote,
  :not(pre) > code .hljs-template-variable,
  :not(pre) > code .hljs-regexp,
  :not(pre) > code .hljs-subst {
    color: var(--text-color) !important;
    background: transparent !important;
    background-color: transparent !important;
    font-weight: inherit !important;
    font-style: inherit !important;
    text-decoration: none !important;
  }
`;
var fontTransitionCSS = `
  .markdown-slide * {
    transition: font-size 0.2s ease-in-out;
  }
  
  /* Disable transitions and dynamic sizing on form elements to prevent flashing */
  .markdown-slide input,
  .markdown-slide label,
  .markdown-slide button,
  .markdown-slide input[type="checkbox"],
  .markdown-slide input[type="radio"] {
    transition: none !important;
    font-size: inherit !important; /* Prevent dynamic font sizing from affecting form elements */
  }
  
  /* Ensure checkbox labels maintain fixed sizing */
  .markdown-slide label[for*="checkbox"] {
    font-size: 1rem !important; /* Fixed size for checkbox labels */
  }
  
  /* Remove top margin from any first element - must override inline styles */
  .markdown-slide > *:first-child,
  .markdown-slide > *:first-child > *:first-child {
    margin-top: 0 !important;
  }

  /* Specifically target all possible first-child elements */
  .markdown-slide > h1:first-child,
  .markdown-slide > h2:first-child,
  .markdown-slide > h3:first-child,
  .markdown-slide > h4:first-child,
  .markdown-slide > h5:first-child,
  .markdown-slide > h6:first-child,
  .markdown-slide > p:first-child,
  .markdown-slide > ul:first-child,
  .markdown-slide > ol:first-child,
  .markdown-slide > div:first-child,
  .markdown-slide > blockquote:first-child,
  .markdown-slide > pre:first-child {
    margin-top: 0 !important;
  }
`;
var stylesInjected = false;
var injectStyles = () => {
  if (typeof document !== "undefined" && !stylesInjected) {
    if (!document.getElementById("markdown-slide-highlight-overrides")) {
      const highlightStyle = document.createElement("style");
      highlightStyle.id = "markdown-slide-highlight-overrides";
      highlightStyle.textContent = highlightOverrides;
      document.head.appendChild(highlightStyle);
    }
    if (!document.getElementById("markdown-slide-font-transitions")) {
      const transitionStyle = document.createElement("style");
      transitionStyle.id = "markdown-slide-font-transitions";
      transitionStyle.textContent = fontTransitionCSS;
      document.head.appendChild(transitionStyle);
    }
    stylesInjected = true;
  }
};
var IndustryMarkdownSlide = React13.memo(function IndustryMarkdownSlide2({
  content,
  slideIdPrefix,
  slideIndex,
  isVisible = false,
  onLinkClick,
  onCheckboxChange,
  onCopyMermaidError,
  onShowMermaidInPanel,
  handleRunBashCommand,
  handlePromptCopy,
  enableHtmlPopout = true,
  autoFocusOnVisible = true,
  searchQuery,
  slideHeaderMarginTopOverride,
  theme: themeOverride,
  fontSizeScale = 1,
  containerWidth,
  transparentBackground = false,
  additionalPadding,
  disableScroll = false,
  minScreenWidth: _minScreenWidth,
  maxScreenWidth: _maxScreenWidth,
  enableKeyboardScrolling = true,
  keyboardScrollConfig,
  repositoryInfo,
  editable = false
}) {
  const slideRef = useRef7(null);
  const scrollPositionsRef = useRef7(new Map);
  const [measuredContainerWidth, setMeasuredContainerWidth] = useState9(null);
  let chunks = [];
  try {
    if (typeof content === "string") {
      chunks = parseMarkdownChunks2(content, slideIdPrefix);
    } else {}
  } catch (error) {
    console.error("Error parsing markdown chunks:", error);
  }
  const [checkedItems, setCheckedItems] = useState9({});
  const { htmlModalOpen, htmlModalContent, openHtmlModal, closeHtmlModal } = useIndustryHtmlModal();
  const [mermaidModalOpen, setMermaidModalOpen] = useState9(false);
  const [mermaidModalCode, setMermaidModalCode] = useState9("");
  const [placeholderModalOpen, setPlaceholderModalOpen] = useState9(false);
  const [placeholderModalData, setPlaceholderModalData] = useState9(null);
  useEffect7(() => {
    injectStyles();
  }, []);
  useEffect7(() => {
    if (containerWidth !== undefined) {
      return;
    }
    if (!slideRef.current) {
      return;
    }
    const setupResizeObserver = () => {
      const parentContainer = slideRef.current?.parentElement;
      if (!parentContainer) {
        return;
      }
      const resizeObserver2 = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { width } = entry.contentRect;
          setMeasuredContainerWidth(width);
        }
      });
      resizeObserver2.observe(parentContainer);
      return resizeObserver2;
    };
    let resizeObserver = setupResizeObserver();
    if (!resizeObserver) {
      const timeoutId = setTimeout(() => {
        resizeObserver = setupResizeObserver();
      }, 100);
      return () => {
        clearTimeout(timeoutId);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      };
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [containerWidth]);
  const defaultScrollConfig = {
    scrollAmount: 100,
    pageScrollRatio: 0.8,
    smoothScroll: true,
    keys: {
      scrollUp: ["ArrowUp"],
      scrollDown: ["ArrowDown"],
      pageUp: ["PageUp"],
      pageDown: ["PageDown"]
    },
    enableDebugLogging: false
  };
  const scrollConfig = {
    ...defaultScrollConfig,
    ...keyboardScrollConfig,
    keys: {
      ...defaultScrollConfig.keys,
      ...keyboardScrollConfig?.keys
    }
  };
  const handleKeyDown = useCallback((event) => {
    if (!enableKeyboardScrolling) {
      return;
    }
    if (!isVisible) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDEAB Slide ${slideIndex} ignoring key press - not visible`);
      }
      return;
    }
    if (scrollConfig.enableDebugLogging) {
      console.log(`\uD83D\uDD39 Slide ${slideIndex} key pressed:`, event.key, "Target:", event.target);
    }
    if (!slideRef.current) {
      if (scrollConfig.enableDebugLogging) {
        console.log("❌ slideRef.current is null");
      }
      return;
    }
    const container = slideRef.current;
    const scrollInfo = {
      scrollTop: container.scrollTop,
      scrollHeight: container.scrollHeight,
      clientHeight: container.clientHeight,
      canScroll: container.scrollHeight > container.clientHeight,
      maxScroll: container.scrollHeight - container.clientHeight
    };
    if (scrollConfig.enableDebugLogging) {
      console.log(`\uD83D\uDCCA Slide ${slideIndex} Scroll Info:`, scrollInfo);
      let parent = container.parentElement;
      let level = 1;
      while (parent && level <= 3) {
        const parentScrollInfo = {
          level,
          tagName: parent.tagName,
          className: parent.className,
          scrollTop: parent.scrollTop,
          scrollHeight: parent.scrollHeight,
          clientHeight: parent.clientHeight,
          canScroll: parent.scrollHeight > parent.clientHeight,
          overflowY: getComputedStyle(parent).overflowY
        };
        console.log(`\uD83D\uDCCA Slide ${slideIndex} Parent ${level} Info:`, parentScrollInfo);
        parent = parent.parentElement;
        level++;
      }
    }
    const isScrollDown = scrollConfig.keys.scrollDown.includes(event.key);
    const isScrollUp = scrollConfig.keys.scrollUp.includes(event.key);
    const isPageDown = scrollConfig.keys.pageDown.includes(event.key);
    const isPageUp = scrollConfig.keys.pageUp.includes(event.key);
    if (!isScrollDown && !isScrollUp && !isPageDown && !isPageUp) {
      return;
    }
    let scrollTarget = container;
    if (!scrollInfo.canScroll) {
      let parent = container.parentElement;
      while (parent) {
        if (parent.scrollHeight > parent.clientHeight) {
          if (scrollConfig.enableDebugLogging) {
            console.log(`\uD83C\uDFAF Slide ${slideIndex} Found scrollable parent:`, parent.tagName, parent.className);
          }
          scrollTarget = parent;
          break;
        }
        parent = parent.parentElement;
      }
    }
    if (scrollTarget.scrollHeight <= scrollTarget.clientHeight) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⚠️ Slide ${slideIndex} Cannot scroll - content fits in container`);
      }
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    let scrollAmount = 0;
    if (isScrollDown) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⬇️ Slide ${slideIndex} Scroll down pressed`);
      }
      scrollAmount = scrollConfig.scrollAmount;
    } else if (isScrollUp) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`⬆️ Slide ${slideIndex} Scroll up pressed`);
      }
      scrollAmount = -scrollConfig.scrollAmount;
    } else if (isPageDown) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDCC4⬇️ Slide ${slideIndex} Page down pressed`);
      }
      scrollAmount = scrollTarget.clientHeight * scrollConfig.pageScrollRatio;
    } else if (isPageUp) {
      if (scrollConfig.enableDebugLogging) {
        console.log(`\uD83D\uDCC4⬆️ Slide ${slideIndex} Page up pressed`);
      }
      scrollAmount = -scrollTarget.clientHeight * scrollConfig.pageScrollRatio;
    }
    const beforeScroll = scrollTarget.scrollTop;
    scrollTarget.scrollBy({
      top: scrollAmount,
      behavior: scrollConfig.smoothScroll ? "smooth" : "auto"
    });
    if (scrollConfig.enableDebugLogging) {
      setTimeout(() => {
        const afterScroll = scrollTarget.scrollTop;
        console.log(`\uD83D\uDCC8 Slide ${slideIndex} Scroll: ${beforeScroll} → ${afterScroll} (diff: ${afterScroll - beforeScroll})`);
      }, scrollConfig.smoothScroll ? 100 : 0);
    }
  }, [enableKeyboardScrolling, isVisible, slideIndex, scrollConfig]);
  useEffect7(() => {
    if (autoFocusOnVisible && isVisible && slideRef.current) {
      slideRef.current.focus({ preventScroll: true });
    }
  }, [autoFocusOnVisible, isVisible]);
  const openPlaceholderModal = (placeholders, promptContent) => {
    if (!handlePromptCopy)
      return;
    setPlaceholderModalData({ placeholders, promptContent });
    setPlaceholderModalOpen(true);
  };
  const closePlaceholderModal = () => {
    setPlaceholderModalOpen(false);
    setPlaceholderModalData(null);
  };
  const openMermaidModal = (code) => {
    setMermaidModalCode(code);
    setMermaidModalOpen(true);
  };
  const closeMermaidModal = () => {
    setMermaidModalOpen(false);
    setMermaidModalCode("");
  };
  const baseTheme = themeOverride ?? theme;
  const theme2 = useMemo2(() => {
    if (fontSizeScale === 1)
      return baseTheme;
    return {
      ...baseTheme,
      fontSizes: baseTheme.fontSizes.map((size) => Math.round(size * fontSizeScale))
    };
  }, [baseTheme, fontSizeScale]);
  const calculateSlidePadding = useMemo2(() => {
    const effectiveContainerWidth = containerWidth ?? measuredContainerWidth ?? 800;
    const paddingPercentage = 0.03;
    const horizontalPadding = Math.max(5, Math.round(effectiveContainerWidth * paddingPercentage));
    const verticalPadding = Math.max(5, Math.round(effectiveContainerWidth * (paddingPercentage - 0.015)));
    const result = {
      vertical: `${verticalPadding}px`,
      horizontal: `${horizontalPadding}px`
    };
    return result;
  }, [containerWidth, measuredContainerWidth]);
  const finalPadding = useMemo2(() => {
    const basePadding = calculateSlidePadding.horizontal;
    const baseVerticalPadding = calculateSlidePadding.vertical;
    const baseHorizontalValue = parseInt(basePadding.replace("px", ""), 10);
    const baseVerticalValue = parseInt(baseVerticalPadding.replace("px", ""), 10);
    const leftExtra = additionalPadding?.left ? parseInt(additionalPadding.left.replace("px", ""), 10) : 0;
    const rightExtra = additionalPadding?.right ? parseInt(additionalPadding.right.replace("px", ""), 10) : 0;
    const topExtra = additionalPadding?.top ? parseInt(additionalPadding.top.replace("px", ""), 10) : 0;
    const bottomExtra = additionalPadding?.bottom ? parseInt(additionalPadding.bottom.replace("px", ""), 10) : 0;
    const top = Math.round(baseVerticalValue * 1.5) + topExtra;
    const right = baseHorizontalValue + rightExtra;
    const bottom = Math.round(baseVerticalValue * 1.5) + bottomExtra;
    const left = baseHorizontalValue + leftExtra;
    return `${top}px ${right}px ${bottom}px ${left}px`;
  }, [calculateSlidePadding.horizontal, calculateSlidePadding.vertical, additionalPadding]);
  useEffect7(() => {
    const slideElement = slideRef.current;
    if (slideElement) {
      const handleScroll = () => {
        scrollPositionsRef.current.set(slideIndex, slideElement.scrollTop || 0);
      };
      slideElement.addEventListener("scroll", handleScroll);
      return () => {
        slideElement.removeEventListener("scroll", handleScroll);
      };
    }
    return;
  }, [slideIndex]);
  useLayoutEffect(() => {
    if (slideRef.current) {
      const savedPosition = scrollPositionsRef.current.get(slideIndex) ?? 0;
      slideRef.current.scrollTop = savedPosition;
    }
  }, [slideIndex]);
  const sanitizeSchema = useMemo2(() => ({
    ...defaultSchema,
    tagNames: [...defaultSchema.tagNames || [], "picture", "source", "mark"],
    attributes: {
      ...defaultSchema.attributes,
      mark: ["style", "className"],
      code: [...defaultSchema.attributes?.code || [], "className", "style"],
      span: [...defaultSchema.attributes?.span || [], "className", "style"],
      pre: [...defaultSchema.attributes?.pre || [], "className", "style"],
      div: [...defaultSchema.attributes?.div || [], "style", "className", "id"],
      p: [...defaultSchema.attributes?.p || [], "style", "className", "id"],
      h1: [...defaultSchema.attributes?.h1 || [], "style", "className", "id"],
      h2: [...defaultSchema.attributes?.h2 || [], "style", "className", "id"],
      h3: [...defaultSchema.attributes?.h3 || [], "style", "className", "id"],
      h4: [...defaultSchema.attributes?.h4 || [], "style", "className", "id"],
      h5: [...defaultSchema.attributes?.h5 || [], "style", "className", "id"],
      h6: [...defaultSchema.attributes?.h6 || [], "style", "className", "id"],
      strong: [...defaultSchema.attributes?.strong || [], "style", "className"],
      em: [...defaultSchema.attributes?.em || [], "style", "className"],
      ul: [...defaultSchema.attributes?.ul || [], "style", "className"],
      ol: [...defaultSchema.attributes?.ol || [], "style", "className"],
      li: [...defaultSchema.attributes?.li || [], "style", "className"],
      a: [...defaultSchema.attributes?.a || [], "style", "className"],
      img: [...defaultSchema.attributes?.img || [], "style", "className"],
      picture: [...defaultSchema.attributes?.picture || [], "style", "className"],
      source: [
        ...defaultSchema.attributes?.source || [],
        "srcSet",
        "media",
        "type",
        "sizes",
        "style",
        "className"
      ],
      table: [...defaultSchema.attributes?.table || [], "style", "className"],
      thead: [...defaultSchema.attributes?.thead || [], "style", "className"],
      tbody: [...defaultSchema.attributes?.tbody || [], "style", "className"],
      tr: [...defaultSchema.attributes?.tr || [], "style", "className"],
      th: [...defaultSchema.attributes?.th || [], "style", "className"],
      td: [...defaultSchema.attributes?.td || [], "style", "className"],
      blockquote: [...defaultSchema.attributes?.blockquote || [], "style", "className"],
      hr: [...defaultSchema.attributes?.hr || [], "style", "className"],
      label: [...defaultSchema.attributes?.label || [], "style", "className", "for"],
      input: [
        ...defaultSchema.attributes?.input || [],
        "style",
        "className",
        "type",
        "placeholder",
        "value",
        "checked",
        "disabled"
      ],
      button: [
        ...defaultSchema.attributes?.button || [],
        "style",
        "className",
        "type",
        "disabled"
      ],
      details: [...defaultSchema.attributes?.details || [], "style", "className", "open"],
      summary: [...defaultSchema.attributes?.summary || [], "style", "className"],
      footer: [...defaultSchema.attributes?.footer || [], "style", "className"],
      header: [...defaultSchema.attributes?.header || [], "style", "className"],
      section: [...defaultSchema.attributes?.section || [], "style", "className"]
    }
  }), []);
  const rootMargin = isVisible ? "0px" : "100px";
  const getMarkdownComponents = useCallback((chunkIndex) => {
    const baseComponents = createIndustryMarkdownComponents({
      theme: theme2,
      slideIdPrefix,
      slideIndex,
      onLinkClick,
      onCheckboxChange,
      checkedItems,
      setCheckedItems,
      openHtmlModal,
      openPlaceholderModal: handlePromptCopy ? openPlaceholderModal : undefined,
      handleRunBashCommand,
      enableHtmlPopout,
      slideHeaderMarginTopOverride,
      index: chunkIndex,
      repositoryInfo,
      editable
    });
    if (searchQuery) {
      return {
        ...baseComponents,
        mark: ({ children }) => /* @__PURE__ */ React13.createElement("mark", {
          style: {
            backgroundColor: theme2.colors.highlightBg || "rgba(255, 193, 7, 0.25)",
            color: theme2.colors.text,
            padding: "0.05em 0.15em",
            borderRadius: `${theme2.radii[0]}px`,
            border: `1px solid ${theme2.colors.highlightBorder || "rgba(255, 193, 7, 0.4)"}`,
            fontWeight: "inherit",
            textDecoration: "none"
          }
        }, children)
      };
    }
    return baseComponents;
  }, [
    theme2,
    slideIdPrefix,
    slideIndex,
    onLinkClick,
    onCheckboxChange,
    checkedItems,
    setCheckedItems,
    openHtmlModal,
    handlePromptCopy,
    handleRunBashCommand,
    enableHtmlPopout,
    slideHeaderMarginTopOverride,
    repositoryInfo,
    searchQuery,
    editable
  ]);
  return /* @__PURE__ */ React13.createElement("div", {
    className: "markdown-slide",
    ref: slideRef,
    style: {
      height: "100%",
      overflowY: disableScroll ? "visible" : "auto",
      overflowX: disableScroll ? "visible" : "hidden",
      position: "relative",
      backgroundColor: transparentBackground ? "transparent" : theme2.colors.background,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.body,
      padding: finalPadding,
      outline: "none",
      border: "2px solid transparent",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box"
    },
    tabIndex: 0,
    onKeyDown: handleKeyDown,
    onClick: () => {
      if (slideRef.current) {
        slideRef.current.focus();
      }
    }
  }, chunks.length === 0 ? /* @__PURE__ */ React13.createElement("div", {
    style: {
      padding: theme2.space[4],
      textAlign: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2]
    }
  }, "No content to display") : chunks.map((chunk, index) => {
    if (chunk.type === "markdown_chunk") {
      const processedContent = searchQuery ? highlightSearchMatches(chunk.content, searchQuery) : chunk.content;
      return /* @__PURE__ */ React13.createElement(ReactMarkdown, {
        key: `${chunk.id}-${JSON.stringify(theme2.colors.accent)}`,
        remarkPlugins: [remarkGfm],
        rehypePlugins: [
          rehypeRaw,
          [rehypeSanitize, sanitizeSchema],
          rehypeSlug,
          rehypeHighlight
        ],
        components: getMarkdownComponents(index)
      }, processedContent);
    }
    if (chunk.type === "mermaid_chunk") {
      const mermaidProps = {
        id: chunk.id,
        code: chunk.content,
        onCopyError: onCopyMermaidError,
        rootMargin,
        theme: theme2,
        onExpandClick: () => openMermaidModal(chunk.content)
      };
      if (onShowMermaidInPanel) {
        mermaidProps.onShowInPanel = onShowMermaidInPanel;
      }
      return /* @__PURE__ */ React13.createElement(IndustryLazyMermaidDiagram, {
        key: chunk.id,
        ...mermaidProps
      });
    }
    return null;
  }), /* @__PURE__ */ React13.createElement(IndustryHtmlModal, {
    isOpen: htmlModalOpen,
    onClose: closeHtmlModal,
    htmlContent: htmlModalContent,
    theme: theme2
  }), /* @__PURE__ */ React13.createElement(IndustryMermaidModal, {
    isOpen: mermaidModalOpen,
    onClose: closeMermaidModal,
    mermaidCode: mermaidModalCode,
    theme: theme2
  }), handlePromptCopy && placeholderModalData && /* @__PURE__ */ React13.createElement(IndustryPlaceholderModal, {
    isOpen: placeholderModalOpen,
    onClose: closePlaceholderModal,
    placeholders: placeholderModalData.placeholders,
    promptContent: placeholderModalData.promptContent,
    onCopy: handlePromptCopy,
    theme: theme2
  }));
});
// industryMarkdown/components/SlidePresentation.tsx
import { AnimatedResizableLayout } from "@principal-ade/panels";
import React17, { useState as useState10, useCallback as useCallback2, useRef as useRef9, useEffect as useEffect9 } from "react";

// industryMarkdown/utils/extractSlideTitles.ts
function extractSlideTitle2(content, slideIndex) {
  const lines = content.split(`
`);
  for (const line of lines) {
    const trimmedLine = line.trim();
    if (trimmedLine.startsWith("#")) {
      const match = trimmedLine.match(/^#{1,2}\s+(.+)$/);
      if (match && match[1]) {
        return match[1].replace(/\*\*/g, "").replace(/\*/g, "").replace(/`/g, "").replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").trim();
      }
    }
  }
  return `Slide ${slideIndex + 1}`;
}
function extractAllSlideTitles(slides) {
  return slides.map((slide, index) => extractSlideTitle2(slide, index));
}

// industryMarkdown/components/SlideNavigationHeader.tsx
import {
  ChevronLeft,
  ChevronRight,
  Maximize2,
  Minimize2,
  Menu,
  PanelLeftClose,
  PanelRightClose,
  Columns,
  ExternalLink,
  X
} from "lucide-react";
import React15 from "react";

// industryMarkdown/components/FocusLeftIcon.tsx
import React14 from "react";
var FocusLeftIcon = ({
  size = 18,
  color = "currentColor",
  style
}) => /* @__PURE__ */ React14.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style
}, /* @__PURE__ */ React14.createElement("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "1"
}), /* @__PURE__ */ React14.createElement("path", {
  d: "M9 12L15 12M15 12L12 9M15 12L12 15",
  strokeWidth: "1.5"
}));
var FocusRightIcon = ({
  size = 18,
  color = "currentColor",
  style
}) => /* @__PURE__ */ React14.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style
}, /* @__PURE__ */ React14.createElement("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "1"
}), /* @__PURE__ */ React14.createElement("path", {
  d: "M15 12L9 12M9 12L12 9M9 12L12 15",
  strokeWidth: "1.5"
}));

// industryMarkdown/components/SlideNavigationHeader.tsx
var HeaderButton = ({
  onClick,
  disabled = false,
  active = false,
  title,
  theme: theme2,
  children,
  width = "36px",
  minWidth,
  padding
}) => {
  const [isHovered, setIsHovered] = React15.useState(false);
  return /* @__PURE__ */ React15.createElement("button", {
    onClick,
    disabled,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme2.space[1],
      width: minWidth ? undefined : width,
      minWidth,
      height: "36px",
      padding: padding || (minWidth ? `0 ${theme2.space[2]}px` : undefined),
      backgroundColor: isHovered && !disabled && !active ? theme2.colors.backgroundSecondary : active ? theme2.colors.primary : "transparent",
      border: `1px solid ${isHovered && !disabled ? theme2.colors.text : active ? theme2.colors.primary : theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: active ? theme2.colors.background : disabled ? theme2.colors.muted : isHovered ? theme2.colors.text : theme2.colors.textSecondary,
      cursor: disabled ? "not-allowed" : "pointer",
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      opacity: disabled ? 0.5 : 1,
      transition: "all 0.2s ease"
    },
    title
  }, children);
};
var SlideNavigationHeader = ({
  currentSlide,
  totalSlides,
  showTOC,
  isFullscreen,
  showSlideCounter,
  showFullscreenButton,
  showPopoutButton = false,
  isPopout = false,
  isMobile = false,
  theme: theme2,
  viewMode = "single",
  tocDisplayMode = "overlay",
  collapseLeft = false,
  collapseRight = false,
  onPrevious,
  onNext,
  onToggleTOC,
  onToggleFullscreen,
  onPopout,
  onClose,
  onCollapseLeft,
  onCollapseRight
}) => {
  const navigationHeight = "48px";
  return /* @__PURE__ */ React15.createElement("div", {
    style: {
      height: navigationHeight,
      minHeight: navigationHeight,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: `0 ${theme2.space[3]}px`,
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      flexShrink: 0
    }
  }, /* @__PURE__ */ React15.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2]
    }
  }, /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onToggleTOC,
    active: showTOC,
    theme: theme2,
    title: tocDisplayMode === "sidebar" ? showTOC ? "Hide table of contents (T)" : "Show table of contents (T)" : showTOC ? "Close table of contents (Esc)" : "Open table of contents (T)"
  }, /* @__PURE__ */ React15.createElement(Menu, {
    size: 18
  })), /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onPrevious,
    disabled: currentSlide === 0,
    theme: theme2,
    title: "Previous slide",
    minWidth: isMobile ? undefined : "100px",
    width: isMobile ? "36px" : undefined
  }, /* @__PURE__ */ React15.createElement(ChevronLeft, {
    size: 18
  }), !isMobile && "Previous"), viewMode === "book" && onCollapseLeft && /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onCollapseLeft,
    active: collapseRight,
    theme: theme2,
    title: collapseLeft ? "Expand left panel" : collapseRight ? "Show both panels" : "Focus on left panel"
  }, collapseLeft ? /* @__PURE__ */ React15.createElement(PanelLeftClose, {
    size: 18,
    style: { transform: "rotate(180deg)" }
  }) : collapseRight ? /* @__PURE__ */ React15.createElement(Columns, {
    size: 18
  }) : /* @__PURE__ */ React15.createElement(FocusLeftIcon, {
    size: 18
  }))), showSlideCounter && /* @__PURE__ */ React15.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.monospace
    }
  }, viewMode === "book" ? /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("span", {
    style: { fontWeight: 600 }
  }, Math.floor(currentSlide / 2) + 1), /* @__PURE__ */ React15.createElement("span", {
    style: { opacity: 0.5, margin: "0 0.4em" }
  }, "of"), /* @__PURE__ */ React15.createElement("span", {
    style: { fontWeight: 600 }
  }, Math.ceil(totalSlides / 2))) : /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("span", {
    style: { fontWeight: 600 }
  }, currentSlide + 1), /* @__PURE__ */ React15.createElement("span", {
    style: { opacity: 0.5, margin: "0 0.4em" }
  }, "of"), /* @__PURE__ */ React15.createElement("span", {
    style: { fontWeight: 600 }
  }, totalSlides))), /* @__PURE__ */ React15.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: theme2.space[2]
    }
  }, viewMode === "book" && onCollapseRight && /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onCollapseRight,
    active: collapseLeft,
    theme: theme2,
    title: collapseRight ? "Expand right panel" : collapseLeft ? "Show both panels" : "Focus on right panel"
  }, collapseRight ? /* @__PURE__ */ React15.createElement(PanelRightClose, {
    size: 18,
    style: { transform: "rotate(180deg)" }
  }) : collapseLeft ? /* @__PURE__ */ React15.createElement(Columns, {
    size: 18
  }) : /* @__PURE__ */ React15.createElement(FocusRightIcon, {
    size: 18
  })), /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onNext,
    disabled: currentSlide === totalSlides - 1,
    theme: theme2,
    title: "Next slide",
    minWidth: isMobile ? undefined : "100px",
    width: isMobile ? "36px" : undefined
  }, !isMobile && "Next", /* @__PURE__ */ React15.createElement(ChevronRight, {
    size: 18
  })), showPopoutButton && onPopout && !isPopout && /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onPopout,
    theme: theme2,
    title: "Pop out to new window"
  }, /* @__PURE__ */ React15.createElement(ExternalLink, {
    size: 18
  })), isPopout && onClose && /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onClose,
    theme: theme2,
    title: "Close window"
  }, /* @__PURE__ */ React15.createElement(X, {
    size: 18
  })), showFullscreenButton && !showPopoutButton && /* @__PURE__ */ React15.createElement(HeaderButton, {
    onClick: onToggleFullscreen,
    disabled: isMobile,
    theme: theme2,
    title: isMobile ? "Fullscreen not available on mobile" : isFullscreen ? "Exit fullscreen (F)" : "Enter fullscreen (F)"
  }, isFullscreen ? /* @__PURE__ */ React15.createElement(Minimize2, {
    size: 18
  }) : /* @__PURE__ */ React15.createElement(Maximize2, {
    size: 18
  }))));
};

// industryMarkdown/components/SlideSearchBar.tsx
import { Search, X as X2 } from "lucide-react";
import React16, { useRef as useRef8, useEffect as useEffect8 } from "react";
var SlideSearchBar = ({
  showSearch,
  searchQuery,
  setSearchQuery,
  searchResults,
  currentSearchResult,
  searchStartSlide,
  slideTitles,
  theme: theme2,
  onResultClick,
  onClose,
  onClear
}) => {
  const searchInputRef = useRef8(null);
  useEffect8(() => {
    if (showSearch && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showSearch]);
  return /* @__PURE__ */ React16.createElement("div", {
    style: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      height: "56px",
      backgroundColor: theme2.colors.backgroundSecondary,
      borderTop: `1px solid ${theme2.colors.border}`,
      transform: showSearch ? "translateY(0)" : "translateY(100%)",
      transition: "transform 0.2s ease-out",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      padding: `0 ${theme2.space[3]}px`,
      gap: theme2.space[3]
    }
  }, /* @__PURE__ */ React16.createElement(Search, {
    size: 20,
    style: { color: theme2.colors.textSecondary, flexShrink: 0 }
  }), /* @__PURE__ */ React16.createElement("input", {
    ref: searchInputRef,
    type: "text",
    value: searchQuery,
    onChange: (e) => setSearchQuery(e.target.value),
    placeholder: "Search slides...",
    style: {
      flex: "0 0 auto",
      width: "240px",
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: theme2.colors.background,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      outline: "none"
    },
    onFocus: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.primary;
    },
    onBlur: (e) => {
      e.currentTarget.style.borderColor = theme2.colors.border;
    }
  }), searchQuery && /* @__PURE__ */ React16.createElement("div", {
    style: {
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      flexShrink: 0
    }
  }, searchResults.length > 0 ? /* @__PURE__ */ React16.createElement(React16.Fragment, null, searchResults.reduce((sum, r) => sum + r.count, 0), " matches in ", searchResults.length, " ", "slide", searchResults.length !== 1 ? "s" : "") : "No results"), /* @__PURE__ */ React16.createElement("div", {
    style: {
      flex: 1,
      display: "flex",
      gap: theme2.space[1],
      overflowX: "auto",
      overflowY: "hidden",
      alignItems: "center",
      minHeight: "32px",
      padding: `0 ${theme2.space[1]}px`
    }
  }, searchQuery && !searchResults.some((r) => r.slideIndex === searchStartSlide) && /* @__PURE__ */ React16.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: theme2.space[1],
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: theme2.colors.backgroundSecondary,
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      whiteSpace: "nowrap",
      flexShrink: 0,
      opacity: 0.7
    }
  }, /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, "#", searchStartSlide + 1, " (start)"), /* @__PURE__ */ React16.createElement("span", {
    style: { opacity: 0.8 }
  }, "(no matches)")), searchResults.map((result, index) => /* @__PURE__ */ React16.createElement("button", {
    key: result.slideIndex,
    onClick: () => onResultClick(index, result.slideIndex),
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: theme2.space[1],
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: currentSearchResult === index ? theme2.colors.primary : theme2.colors.background,
      border: `1px solid ${currentSearchResult === index ? theme2.colors.primary : theme2.colors.border}`,
      borderRadius: theme2.radii[2],
      color: currentSearchResult === index ? theme2.colors.background : theme2.colors.text,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      cursor: "pointer",
      transition: "all 0.15s ease",
      whiteSpace: "nowrap",
      flexShrink: 0
    },
    onMouseOver: (e) => {
      if (currentSearchResult !== index) {
        e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
      }
    },
    onMouseOut: (e) => {
      if (currentSearchResult !== index) {
        e.currentTarget.style.backgroundColor = theme2.colors.background;
      }
    },
    title: `Slide ${result.slideIndex + 1}: ${slideTitles[result.slideIndex]}`
  }, /* @__PURE__ */ React16.createElement("span", {
    style: { fontWeight: 600 }
  }, "#", result.slideIndex + 1), /* @__PURE__ */ React16.createElement("span", {
    style: { opacity: 0.8 }
  }, "(", result.count, " match", result.count !== 1 ? "es" : "", ")")))), searchQuery && onClear && /* @__PURE__ */ React16.createElement("button", {
    onClick: () => {
      onClear();
      searchInputRef.current?.focus();
    },
    style: {
      display: "flex",
      alignItems: "center",
      padding: `${theme2.space[1]}px ${theme2.space[2]}px`,
      backgroundColor: "transparent",
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.textSecondary,
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.body,
      cursor: "pointer",
      transition: "all 0.2s ease",
      flexShrink: 0
    },
    onMouseOver: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
    },
    onMouseOut: (e) => {
      e.currentTarget.style.backgroundColor = "transparent";
    },
    title: "Clear search"
  }, "Clear"), /* @__PURE__ */ React16.createElement("button", {
    onClick: onClose,
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      backgroundColor: "transparent",
      border: `1px solid ${theme2.colors.border}`,
      borderRadius: theme2.radii[1],
      color: theme2.colors.textSecondary,
      cursor: "pointer",
      transition: "all 0.2s ease",
      flexShrink: 0
    },
    onMouseOver: (e) => {
      e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
    },
    onMouseOut: (e) => {
      e.currentTarget.style.backgroundColor = "transparent";
    },
    title: "Close search (Esc)"
  }, /* @__PURE__ */ React16.createElement(X2, {
    size: 16
  })));
};

// industryMarkdown/components/SlidePresentation.tsx
var SlidePresentation = ({
  slides,
  initialSlide = 0,
  onSlideChange,
  onCheckboxChange,
  showNavigation = true,
  showSlideCounter = true,
  showFullscreenButton = false,
  showPopoutButton = false,
  isPopout = false,
  containerHeight = "100%",
  tocDisplayMode = "overlay",
  tocSidebarPosition = "left",
  initialTocOpen,
  onPopout,
  onClose,
  slideIdPrefix = "slide",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  fontSizeScale,
  theme: theme2
}) => {
  const [isMobile, setIsMobile] = useState10(false);
  useEffect9(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const effectiveTocDisplayMode = isMobile ? "overlay" : tocDisplayMode;
  const defaultTocOpen = initialTocOpen ?? effectiveTocDisplayMode === "sidebar";
  const [currentSlide, setCurrentSlide] = useState10(initialSlide);
  const [isFullscreen, setIsFullscreen] = useState10(false);
  const [showTOC, setShowTOC] = useState10(defaultTocOpen);
  const [showSearch, setShowSearch] = useState10(false);
  const [searchQuery, setSearchQuery] = useState10("");
  const [searchResults, setSearchResults] = useState10([]);
  const [currentSearchResult, setCurrentSearchResult] = useState10(-1);
  const [searchStartSlide, setSearchStartSlide] = useState10(0);
  const containerRef = useRef9(null);
  const slideTitles = extractAllSlideTitles(slides);
  const navigateToSlide = useCallback2((slideIndex) => {
    if (slideIndex >= 0 && slideIndex < slides.length) {
      setCurrentSlide(slideIndex);
      onSlideChange?.(slideIndex);
      if (effectiveTocDisplayMode === "overlay") {
        setShowTOC(false);
      }
    }
  }, [slides.length, onSlideChange, effectiveTocDisplayMode]);
  useEffect9(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      setCurrentSearchResult(-1);
      return;
    }
    const query = searchQuery.toLowerCase();
    const results = [];
    slides.forEach((slide, index) => {
      const slideText = slide.toLowerCase();
      const matches = slideText.split(query).length - 1;
      if (matches > 0) {
        results.push({ slideIndex: index, count: matches });
      }
    });
    setSearchResults(results);
    setCurrentSearchResult(-1);
  }, [searchQuery, slides]);
  const navigateToSearchResult = useCallback2((resultIndex) => {
    if (searchResults.length === 0)
      return;
    let newIndex = resultIndex;
    if (currentSearchResult === -1) {
      newIndex = resultIndex < 0 ? searchResults.length - 1 : 0;
    } else {
      newIndex = (resultIndex % searchResults.length + searchResults.length) % searchResults.length;
    }
    setCurrentSearchResult(newIndex);
    const targetSlide = searchResults[newIndex].slideIndex;
    if (targetSlide !== currentSlide) {
      navigateToSlide(targetSlide);
    }
  }, [searchResults, navigateToSlide, currentSlide, currentSearchResult]);
  const closeSearch = useCallback2(() => {
    setShowSearch(false);
  }, []);
  const clearSearch = useCallback2(() => {
    setSearchQuery("");
    setSearchResults([]);
    setCurrentSearchResult(-1);
    setSearchStartSlide(0);
  }, []);
  const goToPreviousSlide = useCallback2(() => {
    navigateToSlide(currentSlide - 1);
  }, [currentSlide, navigateToSlide]);
  const goToNextSlide = useCallback2(() => {
    navigateToSlide(currentSlide + 1);
  }, [currentSlide, navigateToSlide]);
  const toggleFullscreen = useCallback2(() => {
    if (!containerRef.current)
      return;
    if (!isFullscreen) {
      containerRef.current.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  }, [isFullscreen]);
  useEffect9(() => {
    const handleKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        if (showSearch && (event.key === "Tab" || event.key === "Enter" || event.key === "Escape")) {} else {
          return;
        }
      }
      if ((event.metaKey || event.ctrlKey) && (event.key === "f" || event.key === "F")) {
        event.preventDefault();
        event.stopPropagation();
        if (!showSearch) {
          setSearchStartSlide(currentSlide);
          setShowSearch(true);
        } else {
          closeSearch();
        }
        return;
      }
      if (showSearch) {
        switch (event.key) {
          case "Escape":
            event.preventDefault();
            closeSearch();
            return;
          case "Tab":
            event.preventDefault();
            if (event.shiftKey) {
              navigateToSearchResult(currentSearchResult - 1);
            } else {
              navigateToSearchResult(currentSearchResult + 1);
            }
            return;
          case "Enter":
            event.preventDefault();
            if (currentSearchResult >= 0 && currentSearchResult < searchResults.length) {
              const targetSlide = searchResults[currentSearchResult].slideIndex;
              if (targetSlide !== currentSlide) {
                navigateToSlide(targetSlide);
              }
            }
            closeSearch();
            return;
        }
        return;
      }
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "ArrowRight":
          event.preventDefault();
          goToNextSlide();
          break;
        case " ":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Enter":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Backspace":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "Home":
          event.preventDefault();
          navigateToSlide(0);
          break;
        case "End":
          event.preventDefault();
          navigateToSlide(slides.length - 1);
          break;
        case "f":
        case "F":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            toggleFullscreen();
          }
          break;
        case "Escape":
          if (showTOC) {
            event.preventDefault();
            setShowTOC(false);
          }
          break;
        case "t":
        case "T":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            setShowTOC((prev) => !prev);
          }
          break;
      }
      if (!event.ctrlKey && !event.metaKey && !event.altKey) {
        const num = parseInt(event.key);
        if (num >= 1 && num <= 9 && num <= slides.length) {
          event.preventDefault();
          navigateToSlide(num - 1);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    goToPreviousSlide,
    goToNextSlide,
    navigateToSlide,
    slides.length,
    toggleFullscreen,
    showTOC,
    showSearch,
    closeSearch,
    navigateToSearchResult,
    currentSearchResult,
    tocDisplayMode
  ]);
  useEffect9(() => {
    if (currentSlide >= slides.length && slides.length > 0) {
      setCurrentSlide(slides.length - 1);
    }
  }, [slides.length, currentSlide]);
  return /* @__PURE__ */ React17.createElement("div", {
    ref: containerRef,
    style: {
      height: containerHeight,
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme2.colors.background,
      position: "relative"
    }
  }, showNavigation && /* @__PURE__ */ React17.createElement(SlideNavigationHeader, {
    currentSlide,
    totalSlides: slides.length,
    showTOC,
    isFullscreen,
    showSlideCounter,
    showFullscreenButton,
    showPopoutButton,
    isPopout,
    theme: theme2,
    tocDisplayMode: effectiveTocDisplayMode,
    isMobile,
    onPrevious: goToPreviousSlide,
    onNext: goToNextSlide,
    onToggleTOC: () => setShowTOC((prev) => !prev),
    onToggleFullscreen: toggleFullscreen,
    onPopout,
    onClose
  }), /* @__PURE__ */ React17.createElement("div", {
    style: {
      flex: 1,
      overflow: "hidden",
      position: "relative",
      display: "flex"
    }
  }, effectiveTocDisplayMode === "sidebar" ? /* @__PURE__ */ React17.createElement(AnimatedResizableLayout, {
    key: `toc-${tocSidebarPosition}`,
    collapsed: !showTOC,
    collapsibleSide: tocSidebarPosition,
    leftPanel: tocSidebarPosition === "left" ? /* @__PURE__ */ React17.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React17.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React17.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React17.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React17.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => /* @__PURE__ */ React17.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e) => {
        if (currentSlide !== index) {
          e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e) => {
        if (currentSlide !== index) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React17.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React17.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React17.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), currentSlide === index && /* @__PURE__ */ React17.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }))))) : /* @__PURE__ */ React17.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React17.createElement(IndustryMarkdownSlide, {
      content: slides[currentSlide] || "",
      slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
      slideIndex: currentSlide,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined
    }) : /* @__PURE__ */ React17.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    rightPanel: tocSidebarPosition === "right" ? /* @__PURE__ */ React17.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React17.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React17.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React17.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React17.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => /* @__PURE__ */ React17.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e) => {
        if (currentSlide !== index) {
          e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e) => {
        if (currentSlide !== index) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React17.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React17.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React17.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), currentSlide === index && /* @__PURE__ */ React17.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }))))) : /* @__PURE__ */ React17.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React17.createElement(IndustryMarkdownSlide, {
      content: slides[currentSlide] || "",
      slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
      slideIndex: currentSlide,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined
    }) : /* @__PURE__ */ React17.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    defaultSize: tocSidebarPosition === "left" ? 20 : 80,
    minSize: 15,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React17.createElement(React17.Fragment, null, effectiveTocDisplayMode === "overlay" && /* @__PURE__ */ React17.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      width: "300px",
      backgroundColor: theme2.colors.backgroundSecondary,
      borderRight: `1px solid ${theme2.colors.border}`,
      transform: showTOC ? "translateX(0)" : "translateX(-100%)",
      transition: "transform 0.3s ease",
      zIndex: 10,
      overflowY: "auto",
      overflowX: "hidden"
    }
  }, /* @__PURE__ */ React17.createElement("div", {
    style: {
      padding: theme2.space[3],
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, /* @__PURE__ */ React17.createElement("h3", {
    style: {
      margin: 0,
      fontSize: theme2.fontSizes[3],
      fontFamily: theme2.fonts.heading,
      color: theme2.colors.text,
      fontWeight: 600
    }
  }, "Table of Contents"), /* @__PURE__ */ React17.createElement("p", {
    style: {
      margin: `${theme2.space[1]}px 0 0 0`,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React17.createElement("div", {
    style: { padding: theme2.space[2] }
  }, slideTitles.map((title, index) => /* @__PURE__ */ React17.createElement("button", {
    key: index,
    onClick: () => navigateToSlide(index),
    style: {
      display: "block",
      width: "100%",
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      marginBottom: theme2.space[1],
      backgroundColor: currentSlide === index ? theme2.colors.primary : "transparent",
      border: "none",
      borderRadius: theme2.radii[1],
      color: currentSlide === index ? theme2.colors.background : theme2.colors.text,
      fontSize: theme2.fontSizes[1],
      fontFamily: theme2.fonts.body,
      textAlign: "left",
      cursor: "pointer",
      transition: "all 0.2s ease",
      position: "relative"
    },
    onMouseOver: (e) => {
      if (currentSlide !== index) {
        e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
      }
    },
    onMouseOut: (e) => {
      if (currentSlide !== index) {
        e.currentTarget.style.backgroundColor = "transparent";
      }
    }
  }, /* @__PURE__ */ React17.createElement("div", {
    style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
  }, /* @__PURE__ */ React17.createElement("span", {
    style: {
      display: "inline-block",
      minWidth: "24px",
      fontSize: theme2.fontSizes[0],
      fontFamily: theme2.fonts.monospace,
      opacity: 0.6
    }
  }, index + 1, "."), /* @__PURE__ */ React17.createElement("span", {
    style: {
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, title)), currentSlide === index && /* @__PURE__ */ React17.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)",
      width: "3px",
      height: "60%",
      backgroundColor: currentSlide === index ? theme2.colors.background : theme2.colors.primary,
      borderRadius: "0 2px 2px 0"
    }
  }))))), effectiveTocDisplayMode === "overlay" && showTOC && /* @__PURE__ */ React17.createElement("div", {
    onClick: () => setShowTOC(false),
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 9,
      cursor: "pointer"
    }
  }), /* @__PURE__ */ React17.createElement("div", {
    style: {
      flex: 1,
      position: "relative"
    }
  }, slides.length > 0 ? /* @__PURE__ */ React17.createElement(IndustryMarkdownSlide, {
    content: slides[currentSlide] || "",
    slideIdPrefix: `${slideIdPrefix}-${currentSlide}`,
    slideIndex: currentSlide,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    handlePromptCopy,
    fontSizeScale,
    searchQuery: showSearch ? searchQuery : undefined
  }) : /* @__PURE__ */ React17.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2],
      fontFamily: theme2.fonts.body
    }
  }, "No slides available")))), showNavigation && slides.length > 1 && /* @__PURE__ */ React17.createElement("div", {
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "2px",
      backgroundColor: theme2.colors.border,
      opacity: 0.3
    }
  }, /* @__PURE__ */ React17.createElement("div", {
    style: {
      height: "100%",
      width: `${(currentSlide + 1) / slides.length * 100}%`,
      backgroundColor: theme2.colors.primary,
      transition: "width 0.3s ease"
    }
  })), /* @__PURE__ */ React17.createElement(SlideSearchBar, {
    showSearch,
    searchQuery,
    setSearchQuery,
    searchResults,
    currentSearchResult,
    searchStartSlide,
    slideTitles,
    theme: theme2,
    onResultClick: (index, slideIndex) => {
      setCurrentSearchResult(index);
      navigateToSlide(slideIndex);
    },
    onClose: closeSearch,
    onClear: clearSearch
  }));
};
// industryMarkdown/components/SlidePresentationBook.tsx
import { AnimatedResizableLayout as AnimatedResizableLayout2 } from "@principal-ade/panels";
import React18, { useState as useState11, useCallback as useCallback3, useRef as useRef10, useEffect as useEffect10 } from "react";
var SlidePresentationBook = ({
  slides,
  initialSlide = 0,
  onSlideChange,
  onCheckboxChange,
  showNavigation = true,
  showSlideCounter = true,
  showFullscreenButton = false,
  showPopoutButton = false,
  isPopout = false,
  containerHeight = "100%",
  viewMode = "single",
  tocDisplayMode,
  tocSidebarPosition = "left",
  initialTocOpen,
  onPopout,
  onClose,
  slideIdPrefix = "slide",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  fontSizeScale,
  theme: theme2,
  repositoryInfo,
  width
}) => {
  const [isMobile, setIsMobile] = useState11(false);
  useEffect10(() => {
    const checkMobile = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const effectiveTocDisplayMode = isMobile && viewMode === "single" ? "overlay" : tocDisplayMode ?? (viewMode === "single" ? "sidebar" : "overlay");
  const defaultTocOpen = initialTocOpen ?? false;
  const adjustedInitialSlide = viewMode === "book" ? Math.floor(initialSlide / 2) * 2 : initialSlide;
  const [currentSlide, setCurrentSlide] = useState11(adjustedInitialSlide);
  const [isFullscreen, setIsFullscreen] = useState11(false);
  const [showTOC, setShowTOC] = useState11(defaultTocOpen);
  const [showSearch, setShowSearch] = useState11(false);
  const [searchQuery, setSearchQuery] = useState11("");
  const [searchResults, setSearchResults] = useState11([]);
  const [currentSearchResult, setCurrentSearchResult] = useState11(-1);
  const [searchStartSlide, setSearchStartSlide] = useState11(0);
  const [collapsedSide, setCollapsedSide] = useState11(null);
  const [lastInteractedSide, setLastInteractedSide] = useState11("left");
  const containerRef = useRef10(null);
  const slideTitles = extractAllSlideTitles(slides);
  const stepSize = viewMode === "book" ? 2 : 1;
  const navigateToSlide = useCallback3((slideIndex) => {
    const targetSlide = viewMode === "book" ? Math.floor(slideIndex / 2) * 2 : slideIndex;
    if (targetSlide >= 0 && targetSlide < slides.length) {
      setCurrentSlide(targetSlide);
      onSlideChange?.(targetSlide);
      if (effectiveTocDisplayMode === "overlay") {
        setShowTOC(false);
      }
    }
  }, [slides.length, onSlideChange, viewMode, effectiveTocDisplayMode]);
  useEffect10(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      setCurrentSearchResult(-1);
      return;
    }
    const query = searchQuery.toLowerCase();
    const results = [];
    slides.forEach((slide, index) => {
      const slideText = slide.toLowerCase();
      const matches = slideText.split(query).length - 1;
      if (matches > 0) {
        results.push({ slideIndex: index, count: matches });
      }
    });
    setSearchResults(results);
    setCurrentSearchResult(-1);
  }, [searchQuery, slides]);
  const navigateToSearchResult = useCallback3((resultIndex) => {
    if (searchResults.length === 0)
      return;
    let newIndex = resultIndex;
    if (currentSearchResult === -1) {
      newIndex = resultIndex < 0 ? searchResults.length - 1 : 0;
    } else {
      newIndex = (resultIndex % searchResults.length + searchResults.length) % searchResults.length;
    }
    setCurrentSearchResult(newIndex);
    const targetSlide = searchResults[newIndex].slideIndex;
    if (targetSlide !== currentSlide) {
      navigateToSlide(targetSlide);
    }
  }, [searchResults, navigateToSlide, currentSlide, currentSearchResult]);
  const closeSearch = useCallback3(() => {
    setShowSearch(false);
  }, []);
  const clearSearch = useCallback3(() => {
    setSearchQuery("");
    setSearchResults([]);
    setCurrentSearchResult(-1);
    setSearchStartSlide(0);
  }, []);
  const goToPreviousSlide = useCallback3(() => {
    navigateToSlide(currentSlide - stepSize);
  }, [currentSlide, navigateToSlide, stepSize]);
  const goToNextSlide = useCallback3(() => {
    navigateToSlide(currentSlide + stepSize);
  }, [currentSlide, navigateToSlide, stepSize]);
  const handleCollapseLeft = useCallback3(() => {
    if (collapsedSide === "left") {
      setCollapsedSide(null);
    } else if (collapsedSide === "right") {
      setCollapsedSide(null);
    } else {
      setLastInteractedSide("right");
      setCollapsedSide("right");
    }
  }, [collapsedSide]);
  const handleCollapseRight = useCallback3(() => {
    if (collapsedSide === "right") {
      setCollapsedSide(null);
    } else if (collapsedSide === "left") {
      setCollapsedSide(null);
    } else {
      setLastInteractedSide("left");
      setCollapsedSide("left");
    }
  }, [collapsedSide]);
  const toggleFullscreen = useCallback3(() => {
    if (!containerRef.current)
      return;
    if (!isFullscreen) {
      containerRef.current.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  }, [isFullscreen]);
  useEffect10(() => {
    const handleKeyDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        if (showSearch && (event.key === "Tab" || event.key === "Enter" || event.key === "Escape")) {} else {
          return;
        }
      }
      if ((event.metaKey || event.ctrlKey) && (event.key === "f" || event.key === "F")) {
        event.preventDefault();
        event.stopPropagation();
        if (!showSearch) {
          setSearchStartSlide(currentSlide);
          setShowSearch(true);
        } else {
          closeSearch();
        }
        return;
      }
      if (showSearch) {
        switch (event.key) {
          case "Escape":
            event.preventDefault();
            closeSearch();
            return;
          case "Tab":
            event.preventDefault();
            if (event.shiftKey) {
              navigateToSearchResult(currentSearchResult - 1);
            } else {
              navigateToSearchResult(currentSearchResult + 1);
            }
            return;
          case "Enter":
            event.preventDefault();
            if (currentSearchResult >= 0 && currentSearchResult < searchResults.length) {
              const targetSlide = searchResults[currentSearchResult].slideIndex;
              if (targetSlide !== currentSlide) {
                navigateToSlide(targetSlide);
              }
            }
            closeSearch();
            return;
        }
        return;
      }
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "ArrowRight":
          event.preventDefault();
          goToNextSlide();
          break;
        case " ":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Enter":
          event.preventDefault();
          goToNextSlide();
          break;
        case "Backspace":
          event.preventDefault();
          goToPreviousSlide();
          break;
        case "Home":
          event.preventDefault();
          navigateToSlide(0);
          break;
        case "End":
          event.preventDefault();
          navigateToSlide(slides.length - 1);
          break;
        case "f":
        case "F":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            toggleFullscreen();
          }
          break;
        case "Escape":
          if (showTOC) {
            event.preventDefault();
            setShowTOC(false);
          }
          break;
        case "t":
        case "T":
          if (!event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
            setShowTOC((prev) => !prev);
          }
          break;
      }
      if (!event.ctrlKey && !event.metaKey && !event.altKey) {
        const num = parseInt(event.key);
        if (num >= 1 && num <= 9 && num <= slides.length) {
          event.preventDefault();
          navigateToSlide(num - 1);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    goToPreviousSlide,
    goToNextSlide,
    navigateToSlide,
    slides.length,
    toggleFullscreen,
    showTOC,
    showSearch,
    closeSearch,
    navigateToSearchResult,
    currentSearchResult,
    searchResults,
    effectiveTocDisplayMode
  ]);
  useEffect10(() => {
    if (currentSlide >= slides.length && slides.length > 0) {
      setCurrentSlide(slides.length - 1);
    }
  }, [slides.length, currentSlide]);
  const leftSlideIndex = currentSlide;
  const rightSlideIndex = viewMode === "book" ? currentSlide + 1 : -1;
  return /* @__PURE__ */ React18.createElement("div", {
    ref: containerRef,
    style: {
      height: containerHeight,
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme2.colors.background,
      position: "relative"
    }
  }, showNavigation && /* @__PURE__ */ React18.createElement(SlideNavigationHeader, {
    currentSlide,
    totalSlides: slides.length,
    showTOC,
    isFullscreen,
    showSlideCounter,
    showFullscreenButton,
    showPopoutButton,
    isPopout,
    isMobile,
    theme: theme2,
    viewMode,
    tocDisplayMode: effectiveTocDisplayMode,
    collapseLeft: collapsedSide === "left",
    collapseRight: collapsedSide === "right",
    onPrevious: goToPreviousSlide,
    onNext: goToNextSlide,
    onToggleTOC: () => setShowTOC((prev) => !prev),
    onToggleFullscreen: toggleFullscreen,
    onPopout,
    onClose,
    onCollapseLeft: handleCollapseLeft,
    onCollapseRight: handleCollapseRight
  }), /* @__PURE__ */ React18.createElement("div", {
    style: {
      flex: 1,
      width: "100%",
      overflow: "hidden",
      position: "relative",
      display: "flex"
    }
  }, viewMode === "single" && effectiveTocDisplayMode === "sidebar" ? /* @__PURE__ */ React18.createElement(AnimatedResizableLayout2, {
    key: `toc-${tocSidebarPosition}`,
    collapsed: !showTOC,
    collapsibleSide: tocSidebarPosition,
    leftPanel: tocSidebarPosition === "left" ? /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React18.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => {
      const isCurrentPage = index === currentSlide;
      return /* @__PURE__ */ React18.createElement("button", {
        key: index,
        onClick: () => navigateToSlide(index),
        style: {
          display: "block",
          width: "100%",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          marginBottom: theme2.space[1],
          backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
          border: "none",
          borderRadius: theme2.radii[1],
          color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
          fontSize: theme2.fontSizes[1],
          fontFamily: theme2.fonts.body,
          textAlign: "left",
          cursor: "pointer",
          transition: "all 0.2s ease",
          position: "relative"
        },
        onMouseOver: (e) => {
          if (!isCurrentPage) {
            e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
          }
        },
        onMouseOut: (e) => {
          if (!isCurrentPage) {
            e.currentTarget.style.backgroundColor = "transparent";
          }
        }
      }, /* @__PURE__ */ React18.createElement("div", {
        style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
      }, /* @__PURE__ */ React18.createElement("span", {
        style: {
          display: "inline-block",
          minWidth: "24px",
          fontSize: theme2.fontSizes[0],
          fontFamily: theme2.fonts.monospace,
          opacity: 0.6
        }
      }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, title)), isCurrentPage && /* @__PURE__ */ React18.createElement("div", {
        style: {
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: "60%",
          backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
          borderRadius: "0 2px 2px 0"
        }
      }));
    }))) : /* @__PURE__ */ React18.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width
    }) : /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    rightPanel: tocSidebarPosition === "right" ? /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: theme2.colors.backgroundSecondary,
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        padding: theme2.space[3],
        borderBottom: `1px solid ${theme2.colors.border}`,
        backgroundColor: theme2.colors.background,
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    }, /* @__PURE__ */ React18.createElement("h3", {
      style: {
        margin: 0,
        fontSize: theme2.fontSizes[3],
        fontFamily: theme2.fonts.heading,
        color: theme2.colors.text,
        fontWeight: 600
      }
    }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
      style: {
        margin: `${theme2.space[1]}px 0 0 0`,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        fontFamily: theme2.fonts.body
      }
    }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
      style: { padding: theme2.space[2] }
    }, slideTitles.map((title, index) => {
      const isCurrentPage = index === currentSlide;
      return /* @__PURE__ */ React18.createElement("button", {
        key: index,
        onClick: () => navigateToSlide(index),
        style: {
          display: "block",
          width: "100%",
          padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
          marginBottom: theme2.space[1],
          backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
          border: "none",
          borderRadius: theme2.radii[1],
          color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
          fontSize: theme2.fontSizes[1],
          fontFamily: theme2.fonts.body,
          textAlign: "left",
          cursor: "pointer",
          transition: "all 0.2s ease",
          position: "relative"
        },
        onMouseOver: (e) => {
          if (!isCurrentPage) {
            e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
          }
        },
        onMouseOut: (e) => {
          if (!isCurrentPage) {
            e.currentTarget.style.backgroundColor = "transparent";
          }
        }
      }, /* @__PURE__ */ React18.createElement("div", {
        style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
      }, /* @__PURE__ */ React18.createElement("span", {
        style: {
          display: "inline-block",
          minWidth: "24px",
          fontSize: theme2.fontSizes[0],
          fontFamily: theme2.fonts.monospace,
          opacity: 0.6
        }
      }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
        style: {
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, title)), isCurrentPage && /* @__PURE__ */ React18.createElement("div", {
        style: {
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: "60%",
          backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
          borderRadius: "0 2px 2px 0"
        }
      }));
    }))) : /* @__PURE__ */ React18.createElement("div", {
      style: { height: "100%", width: "100%", position: "relative" }
    }, slides.length > 0 ? /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width
    }) : /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.muted,
        fontSize: theme2.fontSizes[2],
        fontFamily: theme2.fonts.body
      }
    }, "No slides available")),
    defaultSize: tocSidebarPosition === "left" ? 20 : 80,
    minSize: 15,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React18.createElement(React18.Fragment, null, effectiveTocDisplayMode === "overlay" && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      ...isMobile ? {
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        maxHeight: "70vh",
        borderTop: `1px solid ${theme2.colors.border}`,
        borderRadius: `${theme2.radii[2]}px ${theme2.radii[2]}px 0 0`,
        transform: showTOC ? "translateY(0)" : "translateY(100%)"
      } : {
        top: 0,
        left: 0,
        bottom: 0,
        width: "300px",
        borderRight: `1px solid ${theme2.colors.border}`,
        transform: showTOC ? "translateX(0)" : "translateX(-100%)"
      },
      backgroundColor: theme2.colors.backgroundSecondary,
      transition: "transform 0.3s ease",
      zIndex: 10,
      overflowY: "auto",
      overflowX: "hidden"
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: {
      padding: theme2.space[3],
      borderBottom: `1px solid ${theme2.colors.border}`,
      backgroundColor: theme2.colors.background,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, /* @__PURE__ */ React18.createElement("h3", {
    style: {
      margin: 0,
      fontSize: theme2.fontSizes[3],
      fontFamily: theme2.fonts.heading,
      color: theme2.colors.text,
      fontWeight: 600
    }
  }, "Table of Contents"), /* @__PURE__ */ React18.createElement("p", {
    style: {
      margin: `${theme2.space[1]}px 0 0 0`,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, slides.length, " ", slides.length === 1 ? "slide" : "slides")), /* @__PURE__ */ React18.createElement("div", {
    style: { padding: theme2.space[2] }
  }, slideTitles.map((title, index) => {
    const isCurrentPage = viewMode === "book" ? index === leftSlideIndex || index === rightSlideIndex : index === currentSlide;
    return /* @__PURE__ */ React18.createElement("button", {
      key: index,
      onClick: () => navigateToSlide(index),
      style: {
        display: "block",
        width: "100%",
        padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
        marginBottom: theme2.space[1],
        backgroundColor: isCurrentPage ? theme2.colors.primary : "transparent",
        border: "none",
        borderRadius: theme2.radii[1],
        color: isCurrentPage ? theme2.colors.background : theme2.colors.text,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative"
      },
      onMouseOver: (e) => {
        if (!isCurrentPage) {
          e.currentTarget.style.backgroundColor = theme2.colors.backgroundHover;
        }
      },
      onMouseOut: (e) => {
        if (!isCurrentPage) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: { display: "flex", alignItems: "center", gap: theme2.space[2] }
    }, /* @__PURE__ */ React18.createElement("span", {
      style: {
        display: "inline-block",
        minWidth: "24px",
        fontSize: theme2.fontSizes[0],
        fontFamily: theme2.fonts.monospace,
        opacity: 0.6
      }
    }, index + 1, "."), /* @__PURE__ */ React18.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, title)), isCurrentPage && /* @__PURE__ */ React18.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "3px",
        height: "60%",
        backgroundColor: isCurrentPage ? theme2.colors.background : theme2.colors.primary,
        borderRadius: "0 2px 2px 0"
      }
    }));
  }))), effectiveTocDisplayMode === "overlay" && showTOC && /* @__PURE__ */ React18.createElement("div", {
    onClick: () => setShowTOC(false),
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 9,
      cursor: "pointer"
    }
  }), /* @__PURE__ */ React18.createElement("div", {
    style: {
      flex: 1,
      position: "relative",
      display: "flex",
      gap: 0,
      padding: 0,
      backgroundColor: theme2.colors.background,
      width: "100%"
    }
  }, slides.length > 0 ? viewMode === "book" && slides.length > 1 ? /* @__PURE__ */ React18.createElement(AnimatedResizableLayout2, {
    key: `${lastInteractedSide}-${collapsedSide}`,
    collapsed: collapsedSide !== null,
    collapsibleSide: lastInteractedSide,
    leftPanel: /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        overflowY: "auto",
        overflowX: "auto",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    }, /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[leftSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
      slideIndex: leftSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width,
      transparentBackground: true,
      additionalPadding: {
        left: `${theme2.space[4]}px`,
        right: `${theme2.space[2]}px`,
        top: `${theme2.space[3]}px`
      },
      disableScroll: false
    }))),
    rightPanel: rightSlideIndex < slides.length ? /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        position: "relative",
        overflow: "hidden"
      }
    }, /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        width: "100%",
        backgroundColor: "transparent",
        borderRadius: 0,
        boxShadow: "none",
        overflowY: "auto",
        overflowX: "auto",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    }, /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
      content: slides[rightSlideIndex] || "",
      slideIdPrefix: `${slideIdPrefix}-${rightSlideIndex}`,
      slideIndex: rightSlideIndex,
      isVisible: true,
      theme: theme2,
      onCheckboxChange,
      enableHtmlPopout,
      enableKeyboardScrolling,
      autoFocusOnVisible,
      onLinkClick,
      handleRunBashCommand,
      handlePromptCopy,
      fontSizeScale,
      searchQuery: showSearch ? searchQuery : undefined,
      repositoryInfo,
      containerWidth: width,
      transparentBackground: true,
      additionalPadding: {
        left: `${theme2.space[2]}px`,
        right: `${theme2.space[4]}px`,
        top: `${theme2.space[3]}px`
      },
      disableScroll: false
    }))) : /* @__PURE__ */ React18.createElement("div", {
      style: {
        height: "100%",
        backgroundColor: theme2.colors.background,
        borderRadius: 0,
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme2.colors.textSecondary || theme2.colors.muted,
        fontSize: theme2.fontSizes[1],
        fontFamily: theme2.fonts.body,
        fontStyle: "italic",
        padding: `0 ${theme2.space[4]}px 0 ${theme2.space[2]}px`
      }
    }, "End of presentation"),
    defaultSize: 50,
    minSize: 30,
    showCollapseButton: false,
    theme: theme2
  }) : /* @__PURE__ */ React18.createElement("div", {
    style: {
      flex: "1 1 0%",
      backgroundColor: "transparent",
      borderRadius: 0,
      boxShadow: "none",
      overflowY: "auto",
      overflowX: "hidden",
      position: "relative",
      width: "100%",
      ...viewMode === "book" && slides.length === 1 ? {
        display: "flex",
        justifyContent: "center"
      } : {}
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: {
      ...viewMode === "book" && slides.length === 1 ? {
        width: "50%",
        maxWidth: "800px",
        minWidth: "400px",
        height: "100%"
      } : {
        width: "100%",
        height: "100%"
      }
    }
  }, /* @__PURE__ */ React18.createElement(IndustryMarkdownSlide, {
    content: slides[leftSlideIndex] || "",
    slideIdPrefix: `${slideIdPrefix}-${leftSlideIndex}`,
    slideIndex: leftSlideIndex,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    handlePromptCopy,
    fontSizeScale,
    searchQuery: showSearch ? searchQuery : undefined,
    repositoryInfo,
    containerWidth: width,
    transparentBackground: false,
    disableScroll: false
  }))) : /* @__PURE__ */ React18.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme2.colors.muted,
      fontSize: theme2.fontSizes[2],
      fontFamily: theme2.fonts.body
    }
  }, "No slides available")), viewMode === "book" && slides.length > 1 && /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      bottom: theme2.space[3],
      left: theme2.space[3],
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    }
  }, leftSlideIndex + 1), rightSlideIndex < slides.length && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      bottom: theme2.space[3],
      right: theme2.space[3],
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace
    }
  }, rightSlideIndex + 1)))), showNavigation && slides.length > 1 && /* @__PURE__ */ React18.createElement("div", {
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "2px",
      backgroundColor: theme2.colors.border,
      opacity: 0.3
    }
  }, /* @__PURE__ */ React18.createElement("div", {
    style: {
      height: "100%",
      width: `${(currentSlide + stepSize) / slides.length * 100}%`,
      backgroundColor: theme2.colors.primary,
      transition: "width 0.3s ease"
    }
  })), /* @__PURE__ */ React18.createElement(SlideSearchBar, {
    showSearch,
    searchQuery,
    setSearchQuery,
    searchResults,
    currentSearchResult,
    searchStartSlide,
    slideTitles,
    theme: theme2,
    onResultClick: (index, slideIndex) => {
      setCurrentSearchResult(index);
      navigateToSlide(slideIndex);
    },
    onClose: closeSearch,
    onClear: clearSearch
  }));
};
// industryMarkdown/components/DocumentView.tsx
import React19, { useRef as useRef11 } from "react";
var DocumentView = ({
  content,
  onCheckboxChange,
  maxWidth = "900px",
  width,
  slideIdPrefix = "document",
  enableHtmlPopout = true,
  enableKeyboardScrolling = true,
  autoFocusOnVisible = true,
  onLinkClick,
  handleRunBashCommand,
  handlePromptCopy,
  repositoryInfo,
  fontSizeScale,
  theme: theme2,
  transparentBackground = false,
  editable = false
}) => {
  const containerRef = useRef11(null);
  const backgroundColor = transparentBackground ? "transparent" : theme2.colors.background;
  return /* @__PURE__ */ React19.createElement("div", {
    ref: containerRef,
    style: {
      height: "100%",
      overflow: "auto",
      backgroundColor
    }
  }, /* @__PURE__ */ React19.createElement("div", {
    style: {
      maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
      margin: "0 auto",
      height: "100%"
    }
  }, /* @__PURE__ */ React19.createElement(IndustryMarkdownSlide, {
    content,
    slideIdPrefix,
    slideIndex: 0,
    isVisible: true,
    theme: theme2,
    onCheckboxChange,
    enableHtmlPopout,
    enableKeyboardScrolling,
    autoFocusOnVisible,
    onLinkClick,
    handleRunBashCommand,
    fontSizeScale,
    handlePromptCopy,
    repositoryInfo,
    transparentBackground,
    editable,
    containerWidth: width
  })));
};
// industryMarkdown/components/SkillMarkdown.tsx
import React20 from "react";
var formatRelativeTime = (dateString) => {
  try {
    const date = new Date(dateString);
    const now = new Date;
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0)
      return "Today";
    if (diffDays === 1)
      return "Yesterday";
    if (diffDays < 7)
      return `${diffDays} days ago`;
    if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
    }
    if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return `${months} ${months === 1 ? "month" : "months"} ago`;
    }
    const years = Math.floor(diffDays / 365);
    return `${years} ${years === 1 ? "year" : "years"} ago`;
  } catch {
    return dateString;
  }
};
var SkillMetadataSection = ({
  metadata,
  theme: theme2
}) => {
  return /* @__PURE__ */ React20.createElement("div", {
    style: {
      borderBottom: `2px solid ${theme2.colors.border}`,
      paddingBottom: theme2.space[3],
      marginBottom: theme2.space[2]
    }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: theme2.space[2] }
  }, /* @__PURE__ */ React20.createElement("h1", {
    style: {
      fontSize: theme2.fontSizes[6],
      fontWeight: 700,
      margin: 0,
      color: theme2.colors.text,
      fontFamily: theme2.fonts.heading
    }
  }, metadata.name), (metadata.metadata?.["last-updated"] || metadata.license) && /* @__PURE__ */ React20.createElement("div", {
    style: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: theme2.space[1], marginLeft: theme2.space[3], marginTop: theme2.space[1] }
  }, metadata.metadata?.["last-updated"] && /* @__PURE__ */ React20.createElement("span", {
    style: {
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace,
      fontWeight: 500,
      whiteSpace: "nowrap"
    }
  }, formatRelativeTime(metadata.metadata["last-updated"])), metadata.license && /* @__PURE__ */ React20.createElement("span", {
    style: {
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.monospace,
      fontWeight: 500,
      whiteSpace: "nowrap"
    }
  }, metadata.license))), /* @__PURE__ */ React20.createElement("p", {
    style: {
      fontSize: theme2.fontSizes[3],
      color: theme2.colors.textSecondary,
      margin: 0,
      lineHeight: 1.5,
      fontFamily: theme2.fonts.body
    }
  }, metadata.description));
};
var SkillMarkdown = ({
  content,
  theme: theme2,
  className = "",
  onParsed,
  onError,
  showRawOnError = false,
  containerWidth
}) => {
  const [parsed, setParsed] = React20.useState(null);
  const [error, setError] = React20.useState(null);
  React20.useEffect(() => {
    try {
      const skill = parseSkillMarkdown(content);
      setParsed(skill);
      setError(null);
      onParsed?.(skill);
    } catch (err) {
      const error2 = err instanceof Error ? err : new Error(String(err));
      setError(error2);
      setParsed(null);
      onError?.(error2);
    }
  }, [content, onParsed, onError]);
  if (!theme2 || !theme2.space) {
    return /* @__PURE__ */ React20.createElement("div", {
      className,
      style: { width: "100%", height: "100%" }
    }, /* @__PURE__ */ React20.createElement("div", {
      style: { padding: "2rem", textAlign: "center", color: "#856404" }
    }, "Error: Theme not available. Wrap component in ThemeProvider."));
  }
  if (error) {
    if (showRawOnError) {
      return /* @__PURE__ */ React20.createElement("div", {
        className,
        style: {
          width: "100%",
          height: "100%",
          overflow: "auto",
          background: theme2.colors.background
        }
      }, /* @__PURE__ */ React20.createElement("div", {
        style: { padding: theme2.space[3] }
      }, /* @__PURE__ */ React20.createElement(IndustryMarkdownSlide, {
        content,
        theme: theme2,
        slideIdPrefix: "skill-fallback",
        slideIndex: 0,
        isVisible: true,
        containerWidth
      })));
    }
    return /* @__PURE__ */ React20.createElement("div", {
      className,
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        padding: theme2.space[4],
        background: theme2.colors.background,
        overflow: "auto"
      }
    }, /* @__PURE__ */ React20.createElement("div", {
      style: {
        background: "#fff3cd",
        border: "1px solid #ffc107",
        borderRadius: "8px",
        padding: theme2.space[4],
        maxWidth: "600px"
      }
    }, /* @__PURE__ */ React20.createElement("h2", {
      style: { color: "#856404", marginTop: 0 }
    }, "Failed to parse SKILL.md"), /* @__PURE__ */ React20.createElement("p", {
      style: {
        fontWeight: 600,
        color: "#856404",
        fontSize: theme2.fontSizes[0],
        textTransform: "uppercase",
        letterSpacing: "0.5px"
      }
    }, error instanceof SkillParseError && "Parse Error", error instanceof SkillValidationError && "Validation Error", !(error instanceof SkillParseError) && !(error instanceof SkillValidationError) && "Error"), /* @__PURE__ */ React20.createElement("p", {
      style: { color: "#856404", margin: `${theme2.space[3]} 0` }
    }, error.message), error instanceof SkillValidationError && error.field && /* @__PURE__ */ React20.createElement("p", {
      style: {
        fontFamily: theme2.fonts.monospace,
        color: "#856404",
        fontSize: theme2.fontSizes[0]
      }
    }, "Field: ", error.field)));
  }
  if (!parsed) {
    return /* @__PURE__ */ React20.createElement("div", {
      className,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        padding: theme2.space[4],
        color: theme2.colors.textSecondary,
        fontStyle: "italic",
        background: theme2.colors.background
      }
    }, "Loading...");
  }
  return /* @__PURE__ */ React20.createElement("div", {
    className,
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: theme2.colors.background
    }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: { padding: theme2.space[3], paddingBottom: 0 }
  }, /* @__PURE__ */ React20.createElement(SkillMetadataSection, {
    metadata: parsed.metadata,
    theme: theme2
  })), /* @__PURE__ */ React20.createElement("div", {
    style: { flex: 1, overflow: "auto", padding: theme2.space[3], paddingTop: 0 }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: { display: "flex", gap: theme2.space[4], alignItems: "flex-start" }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: { flex: 1, minWidth: 0 }
  }, /* @__PURE__ */ React20.createElement(IndustryMarkdownSlide, {
    content: parsed.body,
    theme: theme2,
    slideIdPrefix: "skill-body",
    slideIndex: 0,
    isVisible: true,
    containerWidth
  })), (parsed.metadata.compatibility || parsed.metadata["allowed-tools"] || parsed.metadata.metadata) && /* @__PURE__ */ React20.createElement("div", {
    style: {
      width: "300px",
      flexShrink: 0,
      padding: theme2.space[3],
      background: theme2.colors.background,
      position: "sticky",
      top: theme2.space[3]
    }
  }, parsed.metadata.compatibility && /* @__PURE__ */ React20.createElement("div", {
    style: { marginBottom: theme2.space[3] }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Compatibility"), /* @__PURE__ */ React20.createElement("div", {
    style: { fontSize: theme2.fontSizes[1], color: theme2.colors.text, fontFamily: theme2.fonts.body }
  }, parsed.metadata.compatibility)), parsed.metadata["allowed-tools"] && parsed.metadata["allowed-tools"].length > 0 && /* @__PURE__ */ React20.createElement("div", {
    style: { marginBottom: theme2.space[3] }
  }, /* @__PURE__ */ React20.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Allowed Tools"), /* @__PURE__ */ React20.createElement("div", {
    style: { display: "flex", flexWrap: "wrap", gap: theme2.space[1] }
  }, parsed.metadata["allowed-tools"].map((tool, index) => /* @__PURE__ */ React20.createElement("span", {
    key: index,
    style: {
      display: "inline-block",
      paddingTop: theme2.space[2],
      paddingBottom: theme2.space[2],
      paddingLeft: theme2.space[3],
      paddingRight: theme2.space[3],
      background: theme2.colors.primary,
      color: theme2.colors.background,
      borderRadius: "4px",
      fontSize: theme2.fontSizes[0],
      fontWeight: 500,
      fontFamily: theme2.fonts.monospace
    }
  }, tool)))), parsed.metadata.metadata && Object.keys(parsed.metadata.metadata).length > 0 && /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontWeight: 600,
      fontSize: theme2.fontSizes[0],
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: theme2.colors.textSecondary,
      marginBottom: theme2.space[1]
    }
  }, "Metadata"), /* @__PURE__ */ React20.createElement("div", {
    style: { display: "flex", flexDirection: "column", gap: theme2.space[1] }
  }, Object.entries(parsed.metadata.metadata).filter(([key]) => key !== "last-updated").map(([key, value]) => /* @__PURE__ */ React20.createElement("div", {
    key
  }, /* @__PURE__ */ React20.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[0],
      fontWeight: 600,
      color: theme2.colors.textSecondary,
      fontFamily: theme2.fonts.body
    }
  }, key, ":"), /* @__PURE__ */ React20.createElement("div", {
    style: {
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.text,
      fontFamily: theme2.fonts.monospace
    }
  }, value)))))))));
};
// industryMarkdown/utils/presentationUtils.ts
var extractSlideTitle3 = extractSlideTitle;
function parseMarkdownIntoPresentationFromSource(source) {
  let presentation;
  switch (source.type) {
    case MarkdownSourceType.WORKSPACE_FILE:
    case MarkdownSourceType.GITHUB_FILE:
    case MarkdownSourceType.DRAFT:
      presentation = parseMarkdownIntoPresentation2(source.content, source.repositoryInfo);
      break;
    default:
      throw new Error(`Unsupported source type: ${source.type}`);
  }
  presentation.source = source;
  return presentation;
}
function createGithubFileSource(content, repositoryInfo) {
  return {
    type: MarkdownSourceType.GITHUB_FILE,
    content,
    repositoryInfo,
    editable: false,
    deletable: false
  };
}
function parseMarkdownIntoPresentation2(markdownContent, repositoryInfo) {
  return parseMarkdownIntoPresentation(markdownContent, repositoryInfo);
}
function createPresentationWithErrorMessage(errorMessage) {
  const errorMessageMarkdown = `# Error Loading Markdown:

${errorMessage}`;
  return {
    slides: [
      {
        id: "error",
        title: extractSlideTitle3(errorMessageMarkdown),
        location: {
          startLine: 0,
          endLine: 0,
          content: errorMessageMarkdown
        },
        chunks: parseMarkdownChunks(errorMessageMarkdown, "slide-error")
      }
    ],
    originalContent: errorMessageMarkdown
  };
}
function reconstructMarkdownContent(presentation) {
  return presentation.slides.map((slide, index) => {
    if (index === 0 && !slide.location.content.startsWith("##")) {
      return slide.location.content;
    }
    return slide.location.content.startsWith("##") ? slide.location.content : `## ${slide.location.content}`;
  }).join(`

`);
}
function getAllSlideTitles(presentation) {
  return presentation.slides.map((slide) => slide.title);
}
function findSlideByTitle(presentation, title) {
  return presentation.slides.find((slide) => slide.title === title);
}
function findSlideIndexByTitle(presentation, title) {
  return presentation.slides.findIndex((slide) => slide.title === title);
}
function updateSlideTitle(slide, newTitle) {
  return {
    ...slide,
    title: newTitle
  };
}
function serializePresentationToMarkdown(presentation) {
  return reconstructMarkdownContent(presentation);
}
function updateSlideContent(slide, newContent) {
  return {
    ...slide,
    location: {
      ...slide.location,
      content: newContent
    },
    title: extractSlideTitle3(newContent),
    chunks: parseMarkdownChunks(newContent, slide.id.split("-")[1] || "slide")
  };
}
function updatePresentationSlide(presentation, index, newContent) {
  const updatedSlides = [...presentation.slides];
  if (index >= 0 && index < updatedSlides.length) {
    updatedSlides[index] = updateSlideContent(updatedSlides[index], newContent);
  }
  return {
    ...presentation,
    slides: updatedSlides,
    originalContent: reconstructMarkdownContent({
      ...presentation,
      slides: updatedSlides
    })
  };
}
export {
  withTheme,
  useIndustryHtmlModal,
  updateSlideTitle,
  updateSlideContent,
  updatePresentationSlide,
  terminalTheme,
  slateTheme,
  serializePresentationToMarkdown,
  scaleThemeFonts,
  resetFontScale,
  regalTheme,
  reconstructMarkdownContent,
  parseMarkdownIntoPresentationFromSource,
  parseMarkdownIntoPresentation2 as parseMarkdownIntoPresentation,
  parseMarkdownChunks2 as parseMarkdownChunks,
  matrixTheme,
  matrixMinimalTheme,
  increaseFontScale,
  getAllSlideTitles,
  findSlideIndexByTitle,
  findSlideByTitle,
  extractSlideTitle3 as extractSlideTitle,
  theme as defaultTheme,
  decreaseFontScale,
  createPresentationWithErrorMessage,
  createIndustryMarkdownComponents,
  createGithubFileSource,
  ThemeProvider,
  SlideSearchBar,
  SlidePresentationBook,
  SlidePresentation,
  SlideNavigationHeader,
  SkillMarkdown,
  IndustryZoomableMermaidDiagram,
  IndustryPlaceholderModal,
  IndustryMermaidModal,
  IndustryMarkdownSlide,
  IndustryLazyMermaidDiagram,
  IndustryHtmlModal,
  DocumentView
};
